import { library } from '@fortawesome/fontawesome-svg-core'

// Syntax via https://github.com/FortAwesome/react-fontawesome/issues/70#issuecomment-381445075
// to reduce bundle size

// Free Icons
import { faAddressBook } from '@fortawesome/free-solid-svg-icons/faAddressBook'
import { faAddressCard } from '@fortawesome/free-solid-svg-icons/faAddressCard'
import { faAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp'
import { faBan } from '@fortawesome/free-solid-svg-icons/faBan'
import { faBolt } from '@fortawesome/free-solid-svg-icons/faBolt'
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook'
import { faBuilding } from '@fortawesome/free-solid-svg-icons/faBuilding'
import { faBullhorn } from '@fortawesome/free-solid-svg-icons/faBullhorn'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt'
import { faCheckSquare } from '@fortawesome/free-solid-svg-icons/faCheckSquare'
import { faChild } from '@fortawesome/free-solid-svg-icons/faChild'
import { faCoffee } from '@fortawesome/free-solid-svg-icons/faCoffee'
import { faCopy } from '@fortawesome/free-solid-svg-icons/faCopy'
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload'
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit'
import { faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons/faEnvelopeOpen'
import { faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons/faEnvelopeOpenText'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle'
import { faFileAlt } from '@fortawesome/free-solid-svg-icons/faFileAlt'
import { faFileWord } from '@fortawesome/free-solid-svg-icons/faFileWord'
import { faGavel } from '@fortawesome/free-solid-svg-icons/faGavel'
import { faGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe'
import { faHandshake } from '@fortawesome/free-solid-svg-icons/faHandshake'
import { faHistory } from '@fortawesome/free-solid-svg-icons/faHistory'
import { faInfo } from '@fortawesome/free-solid-svg-icons/faInfo'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle'
import { faKey } from '@fortawesome/free-solid-svg-icons/faKey'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons/faLightbulb'
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink'
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons/faMobileAlt'
import { faMoneyBillAlt as faMoneyBillAltSolid } from '@fortawesome/free-solid-svg-icons/faMoneyBillAlt'
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane'
import { faPaperclip as faPaperclipSolid } from '@fortawesome/free-solid-svg-icons/faPaperclip'
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt'
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone'
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle'
import { faRss } from '@fortawesome/free-solid-svg-icons/faRss'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { faSearchLocation } from '@fortawesome/free-solid-svg-icons/faSearchLocation'
import { faSearchPlus } from '@fortawesome/free-solid-svg-icons/faSearchPlus'
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { faSquare } from '@fortawesome/free-solid-svg-icons/faSquare'
import { faSuitcase } from '@fortawesome/free-solid-svg-icons/faSuitcase'
import { faThumbtack } from '@fortawesome/free-solid-svg-icons/faThumbtack'
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser'
import { faUserCog } from '@fortawesome/free-solid-svg-icons/faUserCog'
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers'
import { faUsersCog } from '@fortawesome/free-solid-svg-icons/faUsersCog'
import { faBell } from '@fortawesome/free-solid-svg-icons/faBell'

// ProRegular Icons (prefixed with "far")
import { faAddressBook as faAddressBookProRegular } from '@fortawesome/pro-regular-svg-icons/faAddressBook'
import { faAddressCard as faAddressCardProRegular } from '@fortawesome/pro-regular-svg-icons/faAddressCard'
import { faBracketsCurly as faBracketsCurlyProRegular } from '@fortawesome/pro-regular-svg-icons/faBracketsCurly'
import { faAnalytics as faAnalyticsProRegular } from '@fortawesome/pro-regular-svg-icons/faAnalytics'
import { faAngleDown as faAngleDownProRegular } from '@fortawesome/pro-regular-svg-icons/faAngleDown'
import { faAngleLeft as faAngleLeftProRegular } from '@fortawesome/pro-regular-svg-icons/faAngleLeft'
import { faAngleRight as faAngleRightProRegular } from '@fortawesome/pro-regular-svg-icons/faAngleRight'
import { faAngleUp as faAngleUpProRegular } from '@fortawesome/pro-regular-svg-icons/faAngleUp'
import { faArchive as faArchiveProRegular } from '@fortawesome/pro-regular-svg-icons/faArchive'
import { faArrowAltCircleRight as faArrowAltCircleRightProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowAltCircleRight'
import { faArrowCircleDown as faArrowCircleDownProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowCircleDown'
import { faArrowCircleRight as faArrowCircleRightProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowCircleRight'
import { faArrowCircleUp as faArrowCircleUpProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowCircleUp'
import { faArrowDown as faArrowDownProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowDown'
import { faArrowFromLeft as faArrowFromLeftProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowFromLeft'
import { faArrowFromRight as faArrowFromRightProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowFromRight'
import { faArrowLeft as faArrowLeftProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowLeft'
import { faArrowRight as faArrowRightProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowRight'
import { faArrowToBottom as faArrowToBottomProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowToBottom'
import { faArrowsAlt as faArrowsAltProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowsAlt'
import { faArrowUp as faArrowUpProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowUp'
import { faArrowsV as faArrowsVProRegular } from '@fortawesome/pro-regular-svg-icons/faArrowsV'
import { faAt as faAtProRegular } from '@fortawesome/pro-regular-svg-icons/faAt'
import { faAward as faAwardProRegular } from '@fortawesome/pro-regular-svg-icons/faAward'
import { faBan as faBanProRegular } from '@fortawesome/pro-regular-svg-icons/faBan'
import { faBolt as faBoltProRegular } from '@fortawesome/pro-regular-svg-icons/faBolt'
import { faBook as faBookProRegular } from '@fortawesome/pro-regular-svg-icons/faBook'
import { faBoxBallot as faBoxBallotProRegular } from '@fortawesome/pro-regular-svg-icons/faBoxBallot'
import { faBuilding as faBuildingProRegular } from '@fortawesome/pro-regular-svg-icons/faBuilding'
import { faBullhorn as faBullhornProRegular } from '@fortawesome/pro-regular-svg-icons/faBullhorn'
import { faBullseyeArrow as faBullseyeArrowProRegular } from '@fortawesome/pro-regular-svg-icons/faBullseyeArrow'
import { faCalendar as faCalendarProRegular } from '@fortawesome/pro-regular-svg-icons/faCalendar'
import { faCalendarAlt as faCalendarAltProRegular } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt'
import { faCalendarCheck as faCalendarCheckProRegular } from '@fortawesome/pro-regular-svg-icons/faCalendarCheck'
import { faCalendarDay as faCalendarDayProRegular } from '@fortawesome/pro-regular-svg-icons/faCalendarDay'
import { faCalendarMinus as faCalendarMinusProRegular } from '@fortawesome/pro-regular-svg-icons/faCalendarMinus'
import { faCalendarPlus as faCalendarPlusProRegular } from '@fortawesome/pro-regular-svg-icons/faCalendarPlus'
import { faCamera as faCameraProRegular } from '@fortawesome/pro-regular-svg-icons/faCamera'
import { faChartBar as faChartBarProRegular } from '@fortawesome/pro-regular-svg-icons/faChartBar'
import { faChartLine as faChartLineChartLineProRegular, faChartLine as faChartLineProRegular } from '@fortawesome/pro-regular-svg-icons/faChartLine'
import { faCheck as faCheckProRegular } from '@fortawesome/pro-regular-svg-icons/faCheck'
import { faCheckCircle as faCheckCircleProRegular } from '@fortawesome/pro-regular-svg-icons/faCheckCircle'
import { faCheckSquare as faCheckSquareProRegular } from '@fortawesome/pro-regular-svg-icons/faCheckSquare'
import { faChevronDown as faChevronDownProRegular } from '@fortawesome/pro-regular-svg-icons/faChevronDown'
import { faChevronRight as faChevronRightProRegular } from '@fortawesome/pro-regular-svg-icons/faChevronRight'
import { faChevronUp as faChevronUpProRegular } from '@fortawesome/pro-regular-svg-icons/faChevronUp'
import { faChild as faChildProRegular } from '@fortawesome/pro-regular-svg-icons/faChild'
import { faCircle as faCircleProRegular } from '@fortawesome/pro-regular-svg-icons/faCircle'
import { faClipboard as faClipboardProRegular } from '@fortawesome/pro-regular-svg-icons/faClipboard'
import { faClipboardUser as faClipboardUserProRegular } from '@fortawesome/pro-regular-svg-icons/faClipboardUser'
import { faClock as faClockProRegular } from "@fortawesome/pro-regular-svg-icons/faClock"
import { faCloudDownloadAlt as faCloudDownloadAltProRegular } from '@fortawesome/pro-regular-svg-icons/faCloudDownloadAlt'
import { faCode as faCodeProRegular } from '@fortawesome/pro-regular-svg-icons/faCode'
import { faCog as faCogProRegular } from '@fortawesome/pro-regular-svg-icons/faCog'
import { faColumns as faColumnsProRegular } from '@fortawesome/pro-regular-svg-icons/faColumns'
import { faComment as faCommentProRegular } from '@fortawesome/pro-regular-svg-icons/faComment'
import { faCommentAlt as faCommentAltProRegular } from '@fortawesome/pro-regular-svg-icons/faCommentAlt'
import { faCommentDots as faCommentDotsProRegular } from '@fortawesome/pro-regular-svg-icons/faCommentDots'
import { faComments as faCommentsProRegular } from '@fortawesome/pro-regular-svg-icons/faComments'
import { faCommentsAlt as faCommentsAltProRegular } from '@fortawesome/pro-regular-svg-icons/faCommentsAlt'
import { faCopy as faCopyProRegular } from '@fortawesome/pro-regular-svg-icons/faCopy'
import { faCreditCard as faCreditCardProRegular } from '@fortawesome/pro-regular-svg-icons/faCreditCard'
import { faDollarSign as faDollarSignProRegular } from '@fortawesome/pro-regular-svg-icons/faDollarSign'
import { faDotCircle as faDotCircleProRegular } from '@fortawesome/pro-regular-svg-icons/faDotCircle'
import { faDownload as faDownloadProRegular } from '@fortawesome/pro-regular-svg-icons/faDownload'
import { faEdit as faEditProRegular } from '@fortawesome/pro-regular-svg-icons/faEdit'
import { faEllipsisV as faEllipsisVProRegular } from '@fortawesome/pro-regular-svg-icons/faEllipsisV'
import { faEmptySet as faEmptySetRegular } from "@fortawesome/pro-regular-svg-icons/faEmptySet"
import { faEnvelope as faEnvelopeProRegular } from '@fortawesome/pro-regular-svg-icons/faEnvelope'
import { faEnvelopeOpen as faEnvelopeOpenProRegular } from '@fortawesome/pro-regular-svg-icons/faEnvelopeOpen'
import { faEraser as faEraserProRegular } from '@fortawesome/pro-regular-svg-icons/faEraser'
import { faExchangeAlt as faExchangeAltProRegular } from '@fortawesome/pro-regular-svg-icons/faExchangeAlt'
import { faExclamationCircle as faExclamationCircleProRegular } from '@fortawesome/pro-regular-svg-icons/faExclamationCircle'
import { faExclamationTriangle as faExclamationTriangleProRegular } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle'
import { faExternalLink as faExternalLinkProRegular } from '@fortawesome/pro-regular-svg-icons/faExternalLink'
import { faExternalLinkAlt as faExternalLinkAltProRegular } from '@fortawesome/pro-regular-svg-icons/faExternalLinkAlt'
import { faEye as faEyeProRegular } from '@fortawesome/pro-regular-svg-icons/faEye'
import { faFastBackward as faFastBackwardRegular } from '@fortawesome/pro-regular-svg-icons/faFastBackward'
import { faFile as faFileProRegular } from '@fortawesome/pro-regular-svg-icons/faFile'
import { faFileAlt as faFileAltProRegular } from '@fortawesome/pro-regular-svg-icons/faFileAlt'
import { faFileAudio as faFileAudioProRegular } from '@fortawesome/pro-regular-svg-icons/faFileAudio'
import { faFileExcel as faFileExcelProRegular } from '@fortawesome/pro-regular-svg-icons/faFileExcel'
import { faFilePdf as faFilePdfProRegular } from '@fortawesome/pro-regular-svg-icons/faFilePdf'
import { faFileVideo as faFileVideoProRegular } from '@fortawesome/pro-regular-svg-icons/faFileVideo'
import { faFileWord as faFileWordProRegular } from '@fortawesome/pro-regular-svg-icons/faFileWord'
import { faFileTimes as faFileTimesProRegular } from '@fortawesome/pro-regular-svg-icons/faFileTimes'
import { faFlag as faFlagProRegular } from '@fortawesome/pro-regular-svg-icons/faFlag'
import { faFlagAlt as faFlagAltProRegular } from '@fortawesome/pro-regular-svg-icons/faFlagAlt'
import { faFolder as faFolderProRegular } from '@fortawesome/pro-regular-svg-icons/faFolder'
import { faFolderOpen as faFolderOpenRegular } from '@fortawesome/pro-regular-svg-icons/faFolderOpen'
import { faFolders as faFoldersProRegular } from '@fortawesome/pro-regular-svg-icons/faFolders'
import { faGavel as faGavelProRegular } from '@fortawesome/pro-regular-svg-icons/faGavel'
import { faGift as faGiftProRegular } from '@fortawesome/pro-regular-svg-icons/faGift'
import { faGlobe as faGlobeProRegular } from '@fortawesome/pro-regular-svg-icons/faGlobe'
import { faGlobeAmericas as faGlobeAmericasProRegular } from '@fortawesome/pro-regular-svg-icons/faGlobeAmericas'
import { faGraduationCap as faGraduationCapProRegular } from '@fortawesome/pro-regular-svg-icons/faGraduationCap'
import { faHandPaper as faHandPaperProRegular } from '@fortawesome/pro-regular-svg-icons/faHandPaper'
import { faHandPeace as faHandPeaceProRegular } from '@fortawesome/pro-regular-svg-icons/faHandPeace'
import { faHandPointer as faHandPointerProRegular } from '@fortawesome/pro-regular-svg-icons/faHandPointer'
import { faHandshake as faHandshakeProRegular } from '@fortawesome/pro-regular-svg-icons/faHandshake'
import { faHeart as faHeartProRegular } from '@fortawesome/pro-regular-svg-icons/faHeart'
import { faHistory as faHistoryProRegular } from '@fortawesome/pro-regular-svg-icons/faHistory'
import { faHome as faHomeProRegular } from '@fortawesome/pro-regular-svg-icons/faHome'
import { faHospital as faHospitalProRegular } from '@fortawesome/pro-regular-svg-icons/faHospital'
import { faImage as faImageProRegular } from '@fortawesome/pro-regular-svg-icons/faImage'
import { faInfoCircle as faInfoCircleProRegular } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'
import { faLandmark as faLandmarkProRegular } from '@fortawesome/pro-regular-svg-icons/faLandmark'
import { faLayerGroup as faLayerGroupProRegular } from '@fortawesome/pro-regular-svg-icons/faLayerGroup'
import { faLayerPlus as faLayerPlusRegular } from '@fortawesome/pro-regular-svg-icons/faLayerPlus'
import { faLifeRing as faLifeRingProRegular } from '@fortawesome/pro-regular-svg-icons/faLifeRing'
import { faLightbulb as faLightbulbProRegular } from '@fortawesome/pro-regular-svg-icons/faLightbulb'
import { faLink as faLinkProRegular } from '@fortawesome/pro-regular-svg-icons/faLink'
import { faListUl as faListUlProRegular } from '@fortawesome/pro-regular-svg-icons/faListUl'
import { faLocation as faLocationProRegular } from '@fortawesome/pro-regular-svg-icons/faLocation'
import { faLock as faLockProRegular } from '@fortawesome/pro-regular-svg-icons/faLock'
import { faLongArrowLeft as faLongArrowLeftProRegular } from '@fortawesome/pro-regular-svg-icons/faLongArrowLeft'
import { faLongArrowRight as faLongArrowRightProRegular } from '@fortawesome/pro-regular-svg-icons/faLongArrowRight'
import { faMagic as faMagicProRegular } from '@fortawesome/pro-regular-svg-icons/faMagic'
import { faMegaphone as faMegaphoneProRegular } from '@fortawesome/pro-regular-svg-icons/faMegaphone'
import { faMap as faMapProRegular } from '@fortawesome/pro-regular-svg-icons/faMap'
import { faMapMarkerAlt as faMapMarkerAltProRegular } from '@fortawesome/pro-regular-svg-icons/faMapMarkerAlt'
import { faMinus as faMinusProRegular } from '@fortawesome/pro-regular-svg-icons/faMinus'
import { faMinusCircle as faMinusCircleProRegular } from '@fortawesome/pro-regular-svg-icons/faMinusCircle'
import { faMoneyBill as faMoneyBillProRegular } from '@fortawesome/pro-regular-svg-icons/faMoneyBill'
import { faMoneyBillAlt as faMoneyBillAltProRegular } from '@fortawesome/pro-regular-svg-icons/faMoneyBillAlt'
import { faMoneyCheckEditAlt as faMoneyCheckEditAltProRegular } from '@fortawesome/pro-regular-svg-icons/faMoneyCheckEditAlt'
import { faNewspaper as faNewspaperProRegular } from '@fortawesome/pro-regular-svg-icons/faNewspaper'
import { faPaintBrushAlt as faPaintBrushAltProRegular } from '@fortawesome/pro-regular-svg-icons/faPaintBrushAlt'
import { faPalette as faPaletteProRegular } from '@fortawesome/pro-regular-svg-icons/faPalette'
import { faPaperPlane as faPaperPlaneProRegular } from '@fortawesome/pro-regular-svg-icons/faPaperPlane'
import { faPaperclip as faPaperclipRegular } from '@fortawesome/pro-regular-svg-icons/faPaperclip'
import { faPen as faPenProRegular } from '@fortawesome/pro-regular-svg-icons/faPen'
import { faPenAlt as faPenAltProRegular } from '@fortawesome/pro-regular-svg-icons/faPenAlt'
import { faPencil as faPencilProRegular } from '@fortawesome/pro-regular-svg-icons/faPencil'
import { faPencilAlt as faPencilAltProRegular } from '@fortawesome/pro-regular-svg-icons/faPencilAlt'
import { faPhone as faPhoneProRegular } from '@fortawesome/pro-regular-svg-icons/faPhone'
import { faPlus as faPlusProRegular } from '@fortawesome/pro-regular-svg-icons/faPlus'
import { faPlusCircle as faPlusCircleProRegular } from '@fortawesome/pro-regular-svg-icons/faPlusCircle'
import { faPodium as faPodiumProRegular } from '@fortawesome/pro-regular-svg-icons/faPodium'
import { faProjectDiagram as faProjectDiagramProRegular } from '@fortawesome/pro-regular-svg-icons/faProjectDiagram'
import { faQuestionCircle as faQuestionCircleProRegular } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle'
import { faReceipt as faReceiptProRegular } from '@fortawesome/pro-regular-svg-icons/faReceipt'
import { faRibbon as faRibbonProRegular } from '@fortawesome/pro-regular-svg-icons/faRibbon'
import { faRss as faRssProRegular } from '@fortawesome/pro-regular-svg-icons/faRss'
import { faSave as faSaveProRegular } from '@fortawesome/pro-regular-svg-icons/faSave'
import { faSearch as faSearchProRegular } from '@fortawesome/pro-regular-svg-icons/faSearch'
import { faSeedling as faSeedlingProRegular } from '@fortawesome/pro-regular-svg-icons/faSeedling'
import { faShare as faShareProRegular } from '@fortawesome/pro-regular-svg-icons/faShare'
import { faShareAlt as faShareAltProRegular } from '@fortawesome/pro-regular-svg-icons/faShareAlt'
import { faShareSquare as faShareSquareProRegular } from '@fortawesome/pro-regular-svg-icons/faShareSquare'
import { faShieldCheck as faShieldCheckProRegular } from "@fortawesome/pro-regular-svg-icons/faShieldCheck"
import { faSignInAlt as faSignInAltProRegular } from '@fortawesome/pro-regular-svg-icons/faSignInAlt'
import { faSignOutAlt as faSignOutAltProRegular } from '@fortawesome/pro-regular-svg-icons/faSignOutAlt'
import { faSortAmountDown as faSortAmountDownProRegular } from '@fortawesome/pro-regular-svg-icons/faSortAmountDown'
import { faSparkles as faSparklesProRegular } from '@fortawesome/pro-regular-svg-icons/faSparkles'
import { faSquare as faSquareProRegular } from '@fortawesome/pro-regular-svg-icons/faSquare'
import { faStar as faStarProRegular } from '@fortawesome/pro-regular-svg-icons/faStar'
import { faStarShooting as faStarShootingProRegular } from '@fortawesome/pro-regular-svg-icons/faStarShooting'
import { faStickyNote as faStickyNoteProRegular } from '@fortawesome/pro-regular-svg-icons/faStickyNote'
import { faSync as faSyncProRegular } from '@fortawesome/pro-regular-svg-icons/faSync'
import { faTable as faTableProRegular } from '@fortawesome/pro-regular-svg-icons/faTable'
import { faTachometerAltFast as faTachometerAltFastProRegular } from '@fortawesome/pro-regular-svg-icons/faTachometerAltFast'
import { faTag as faTagProRegular } from '@fortawesome/pro-regular-svg-icons/faTag'
import { faThumbsDown as faThumbsDownProRegular } from '@fortawesome/pro-regular-svg-icons/faThumbsDown'
import { faThumbsUp as faThumbsUpProRegular } from '@fortawesome/pro-regular-svg-icons/faThumbsUp'
import { faThumbtack as faThumbtackProRegular } from '@fortawesome/pro-regular-svg-icons/faThumbtack'
import { faTimes as faTimesProRegular } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { faTimesCircle as faTimesCircleProRegular } from '@fortawesome/pro-regular-svg-icons/faTimesCircle'
import { faTrash as faTrashProRegular } from '@fortawesome/pro-regular-svg-icons/faTrash'
import { faTrashAlt as faTrashAltProRegular } from "@fortawesome/pro-regular-svg-icons/faTrashAlt"
import { faUniversity as faUniversityProRegular } from '@fortawesome/pro-regular-svg-icons/faUniversity'
import { faUpload as faUploadProRegular } from '@fortawesome/pro-regular-svg-icons/faUpload'
import { faUsdSquare as faUsdSquareProRegular } from '@fortawesome/pro-regular-svg-icons/faUsdSquare'
import { faUser as faUserProRegular } from '@fortawesome/pro-regular-svg-icons/faUser'
import { faUserCircle as faUserCircleProRegular } from '@fortawesome/pro-regular-svg-icons/faUserCircle'
import { faUserEdit as faUserEditProRegular } from '@fortawesome/pro-regular-svg-icons/faUserEdit'
import { faUserCog as faUserCogProRegular } from '@fortawesome/pro-regular-svg-icons/faUserCog'
import { faUserPlus as faUserPlusProRegular } from '@fortawesome/pro-regular-svg-icons/faUserPlus'
import { faUsers as faUsersProRegular } from '@fortawesome/pro-regular-svg-icons/faUsers'
import { faUsersCog as faUsersCogProRegular } from '@fortawesome/pro-regular-svg-icons/faUsersCog'
import { faVideo as faVideoProRegular } from '@fortawesome/pro-regular-svg-icons/faVideo'
import { faFilter as faFilterRegular } from '@fortawesome/pro-regular-svg-icons/faFilter'
import { faLaugh as faLaughProRegular } from '@fortawesome/pro-regular-svg-icons/faLaugh'
import { faCommentEdit as faCommentEditProRegular } from '@fortawesome/pro-regular-svg-icons/faCommentEdit'
import { faSearchPlus as faSearchPlusProRegular } from '@fortawesome/pro-regular-svg-icons/faSearchPlus'
import { faCompressAlt as faCompressAltProRegular } from '@fortawesome/pro-regular-svg-icons/faCompressAlt'
import { faExpandAlt as faExpandAltProRegular } from '@fortawesome/pro-regular-svg-icons/faExpandAlt'
import { faTasks as faTasksProRegular } from '@fortawesome/pro-regular-svg-icons/faTasks'
import { faClone as faCloneProRegular } from '@fortawesome/pro-regular-svg-icons/faClone'
import { faBell as faBellProRegular } from '@fortawesome/pro-regular-svg-icons/faBell'


// ProSolid Icons (prefixed with "fas")
import { faAddressBook as faAddressBookProSolid } from '@fortawesome/pro-solid-svg-icons/faAddressBook'
import { faAdjust as faAdjustProSolid } from '@fortawesome/pro-solid-svg-icons/faAdjust'
import { faAlignCenter as faAlignCenterProSolid } from '@fortawesome/pro-solid-svg-icons/faAlignCenter'
import { faAlignJustify as faAlignJustifyProSolid } from '@fortawesome/pro-solid-svg-icons/faAlignJustify'
import { faAngleDown as faAngleDownProSolid } from '@fortawesome/pro-solid-svg-icons/faAngleDown'
import { faAngleLeft as faAngleLeftProSolid } from '@fortawesome/pro-solid-svg-icons/faAngleLeft'
import { faAngleRight as faAngleRightProSolid } from '@fortawesome/pro-solid-svg-icons/faAngleRight'
import { faAngleUp as faAngleUpProSolid } from '@fortawesome/pro-solid-svg-icons/faAngleUp'
import { faAngry as faAngryProSolid } from '@fortawesome/pro-solid-svg-icons/faAngry'
import { faAppleAlt as faAppleAltProSolid } from '@fortawesome/pro-solid-svg-icons/faAppleAlt'
import { faArchive as faArchiveProSolid } from '@fortawesome/pro-solid-svg-icons/faArchive'
import { faArrowAltCircleDown as faArrowAltCircleDownProSolid } from '@fortawesome/pro-solid-svg-icons/faArrowAltCircleDown'
import { faArrowAltCircleRight as faArrowAltCircleRightProSolid } from '@fortawesome/pro-solid-svg-icons/faArrowAltCircleRight'
import { faArrowAltCircleUp as faArrowAltCircleUpProSolid } from '@fortawesome/pro-solid-svg-icons/faArrowAltCircleUp'
import { faArrowFromBottom as faArrowFromBottomSolid } from '@fortawesome/pro-solid-svg-icons/faArrowFromBottom'
import { faArrowsAltH as faArrowsAltHProSolid } from '@fortawesome/pro-solid-svg-icons/faArrowsAltH'
import { faAsterisk as faAsteriskProSolid } from '@fortawesome/pro-solid-svg-icons/faAsterisk'
import { faAward as faAwardProSolid } from '@fortawesome/pro-solid-svg-icons/faAward'
import { faBallPile as faBallPileProSolid } from '@fortawesome/pro-solid-svg-icons/faBallPile'
import { faBat as faBatProSolid } from '@fortawesome/pro-solid-svg-icons/faBat'
import { faBath as faBathProSolid } from '@fortawesome/pro-solid-svg-icons/faBath'
import { faBinoculars as faBinocularsProSolid } from '@fortawesome/pro-solid-svg-icons/faBinoculars'
import { faBlog as faBlogProSolid } from '@fortawesome/pro-solid-svg-icons/faBlog'
import { faBook as faBookProSolid } from '@fortawesome/pro-solid-svg-icons/faBook'
import { faBookReader as faBookReaderProSolid } from '@fortawesome/pro-solid-svg-icons/faBookReader'
import { faBriefcase as faBriefcaseProSolid } from '@fortawesome/pro-solid-svg-icons/faBriefcase'
import { faBroadcastTower as faBroadcastTowerProSolid } from '@fortawesome/pro-solid-svg-icons/faBroadcastTower'
import { faBuilding as faBuildingProSolid } from '@fortawesome/pro-solid-svg-icons/faBuilding'
import { faBullhorn as faBullhornProSolid } from '@fortawesome/pro-solid-svg-icons/faBullhorn'
import { faCalendarAlt as faCalendarAltProSolid } from '@fortawesome/pro-solid-svg-icons/faCalendarAlt'
import { faCalendarPlus as faCalendarPlusProSolid } from '@fortawesome/pro-solid-svg-icons/faCalendarPlus'
import { faCaretDown as faCaretDownProSolid } from '@fortawesome/pro-solid-svg-icons/faCaretDown'
import { faCarrot as faCarrotProSolid } from '@fortawesome/pro-solid-svg-icons/faCarrot'
import { faCartPlus as faCartPlusProSolid } from '@fortawesome/pro-solid-svg-icons/faCartPlus'
import { faCat as faCatProSolid } from '@fortawesome/pro-solid-svg-icons/faCat'
import { faChalkboardTeacher as faChalkboardTeacherProSolid } from '@fortawesome/pro-solid-svg-icons/faChalkboardTeacher'
import { faChartBar as faChartBarProSolid } from '@fortawesome/pro-solid-svg-icons/faChartBar'
import { faChartLine as faChartLineProSolid } from '@fortawesome/pro-solid-svg-icons/faChartLine'
import { faChartPie as faChartPieProSolid } from '@fortawesome/pro-solid-svg-icons/faChartPie'
import { faCheck as faCheckProSolid } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faCheckCircle as faCheckCircleProSolid } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { faCircle as faCircleProSolid } from '@fortawesome/pro-solid-svg-icons/faCircle'
import { faCloudDownload as faCloudDownloadProSolid } from '@fortawesome/pro-solid-svg-icons/faCloudDownload'
import { faCloudDownloadAlt as faCloudDownloadAltProSolid } from '@fortawesome/pro-solid-svg-icons/faCloudDownloadAlt'
import { faCode as faCodeProSolid } from '@fortawesome/pro-solid-svg-icons/faCode'
import { faCoffee as faCoffeeProSolid } from '@fortawesome/pro-solid-svg-icons/faCoffee'
import { faCog as faCogProSolid } from '@fortawesome/pro-solid-svg-icons/faCog'
import { faColumns as faColumnsProSolid } from '@fortawesome/pro-solid-svg-icons/faColumns'
import { faComment as faCommentProSolid } from '@fortawesome/pro-solid-svg-icons/faComment'
import { faCommentDots as faCommentDotsProSolid } from '@fortawesome/pro-solid-svg-icons/faCommentDots'
import { faComments as faCommentsProSolid } from '@fortawesome/pro-solid-svg-icons/faComments'
import { faCopy as faCopyProSolid } from '@fortawesome/pro-solid-svg-icons/faCopy'
import { faCow as faCowProSolid } from '@fortawesome/pro-solid-svg-icons/faCow'
import { faDesktop as faDesktopProSolid } from '@fortawesome/pro-solid-svg-icons/faDesktop'
import { faDivide as faDivideProSolid } from '@fortawesome/pro-solid-svg-icons/faDivide'
import { faDog as faDogProSolid } from '@fortawesome/pro-solid-svg-icons/faDog'
import { faDollarSign as faDollarSignProSolid } from '@fortawesome/pro-solid-svg-icons/faDollarSign'
import { faDownload as faDownloadProSolid } from '@fortawesome/pro-solid-svg-icons/faDownload'
import { faEmptySet as faEmptySetProSolid } from "@fortawesome/pro-solid-svg-icons/faEmptySet"
import { faEnvelope as faEnvelopeProSolid } from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import { faEnvelopeOpen as faEnvelopeOpenProSolid } from '@fortawesome/pro-solid-svg-icons/faEnvelopeOpen'
import { faEnvelopeSquare as faEnvelopeSquareProSolid } from '@fortawesome/pro-solid-svg-icons/faEnvelopeSquare'
import { faExchangeAlt as faExchangeAltProSolid } from '@fortawesome/pro-solid-svg-icons/faExchangeAlt'
import { faExclamation as faExclamationProSolid } from '@fortawesome/pro-solid-svg-icons/faExclamation'
import { faExclamationSquare as faExclamationSquareProSolid } from '@fortawesome/pro-solid-svg-icons/faExclamationSquare'
import { faExclamationTriangle as faExclamationTriangleProSolid } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faExternalLink as faExternalLinkSolid } from '@fortawesome/pro-solid-svg-icons/faExternalLink'
import { faEye as faEyeProSolid } from '@fortawesome/pro-solid-svg-icons/faEye'
import { faFastBackward as faFastBackwardSolid } from '@fortawesome/pro-solid-svg-icons/faFastBackward'
import { faFax as faFaxProSolid } from '@fortawesome/pro-solid-svg-icons/faFax'
import { faFile as faFileProSolid } from '@fortawesome/pro-solid-svg-icons/faFile'
import { faFileAlt as faFileAltProSolid } from '@fortawesome/pro-solid-svg-icons/faFileAlt'
import { faFileAudio as faFileAudioProSolid } from '@fortawesome/pro-solid-svg-icons/faFileAudio'
import { faFileInvoice as faFileInvoiceProSolid } from '@fortawesome/pro-solid-svg-icons/faFileInvoice'
import { faFileInvoiceDollar as faFileInvoiceDollarProSolid } from '@fortawesome/pro-solid-svg-icons/faFileInvoiceDollar'
import { faFileSearch as faFileSearchProSolid } from '@fortawesome/pro-solid-svg-icons/faFileSearch'
import { faFilter as faFilterProSolid } from '@fortawesome/pro-solid-svg-icons/faFilter'
import { faFlag as faFlagProSolid } from '@fortawesome/pro-solid-svg-icons/faFlag'
import { faFlagAlt as faFlagAltProSolid } from '@fortawesome/pro-solid-svg-icons/faFlagAlt'
import { faFlask as faFlaskProSolid } from '@fortawesome/pro-solid-svg-icons/faFlask'
import { faFolderOpen as faFolderOpenProSolid } from '@fortawesome/pro-solid-svg-icons/faFolderOpen'
import { faFolders as faFoldersProSolid } from '@fortawesome/pro-solid-svg-icons/faFolders'
import { faFrog as faFrogProSolid } from '@fortawesome/pro-solid-svg-icons/faFrog'
import { faGavel as faGavelProSolid } from '@fortawesome/pro-solid-svg-icons/faGavel'
import { faGift as faGiftProSolid } from '@fortawesome/pro-solid-svg-icons/faGift'
import { faGlassMartini as faGlassMartiniProSolid } from '@fortawesome/pro-solid-svg-icons/faGlassMartini'
import { faGlobe as faGlobeProSolid } from '@fortawesome/pro-solid-svg-icons/faGlobe'
import { faGlobeAmericas as faGlobeAmericasProSolid } from '@fortawesome/pro-solid-svg-icons/faGlobeAmericas'
import { faGraduationCap as faGraduationCapProSolid } from '@fortawesome/pro-solid-svg-icons/faGraduationCap'
import { faGripVertical as faGripVerticalProSolid} from '@fortawesome/pro-solid-svg-icons/faGripVertical'
import { faGripLines as faGripLinesProSolid } from '@fortawesome/pro-solid-svg-icons/faGripLines'
import { faHashtag as faHashtagProSolid } from '@fortawesome/pro-solid-svg-icons/faHashtag'
import { faHeart as faHeartProSolid } from '@fortawesome/pro-solid-svg-icons/faHeart'
import { faHippo as faHippoProSolid } from '@fortawesome/pro-solid-svg-icons/faHippo'
import { faHome as faHomeProSolid } from '@fortawesome/pro-solid-svg-icons/faHome'
import { faHorizontalRule as faHorizontalRuleProSolid } from '@fortawesome/pro-solid-svg-icons/faHorizontalRule'
import { faHourglassEnd as faHourglassEndProSolid } from '@fortawesome/pro-solid-svg-icons/faHourglassEnd'
import { faHourglassStart as faHourglassStartProSolid } from '@fortawesome/pro-solid-svg-icons/faHourglassStart'
import { faInbox as faInboxProSolid } from '@fortawesome/pro-solid-svg-icons/faInbox'
import { faIndustry as faIndustryProSolid } from '@fortawesome/pro-solid-svg-icons/faIndustry'
import { faIslandTropical as faIslandTropicalProSolid } from '@fortawesome/pro-solid-svg-icons/faIslandTropical'
import { faLanguage as faLanguageProSolid } from '@fortawesome/pro-solid-svg-icons/faLanguage'
import { faLaptop as faLaptopProSolid } from '@fortawesome/pro-solid-svg-icons/faLaptop'
import { faLeaf as faLeafProSolid } from '@fortawesome/pro-solid-svg-icons/faLeaf'
import { faList as faListProSolid } from '@fortawesome/pro-solid-svg-icons/faList'
import { faListAlt as faListAltProSolid } from '@fortawesome/pro-solid-svg-icons/faListAlt'
import { faListOl as faListOlProSolid } from '@fortawesome/pro-solid-svg-icons/faListOl'
import { faListUl as faListUlProSolid } from '@fortawesome/pro-solid-svg-icons/faListUl'
import { faLocation as faLocationProSolid } from '@fortawesome/pro-solid-svg-icons/faLocation'
import { faLocationArrow as faLocationArrowProSolid } from '@fortawesome/pro-solid-svg-icons/faLocationArrow'
import { faMagic as faMagicProSolid } from '@fortawesome/pro-solid-svg-icons/faMagic'
import { faMap as faMapProSolid } from '@fortawesome/pro-solid-svg-icons/faMap'
import { faMapMarkedAlt as faMapMarkedAltProSolid } from '@fortawesome/pro-solid-svg-icons/faMapMarkedAlt'
import { faMapPin as faMapPinProSolid } from '@fortawesome/pro-solid-svg-icons/faMapPin'
import { faMapSigns as faMapSignsProSolid } from '@fortawesome/pro-solid-svg-icons/faMapSigns'
import { faMicrophone as faMicrophoneProSolid } from '@fortawesome/pro-solid-svg-icons/faMicrophone'
import { faMinus as faMinusProSolid } from '@fortawesome/pro-solid-svg-icons/faMinus'
import { faMinusCircle as faMinusCircleProSolid } from '@fortawesome/pro-solid-svg-icons/faMinusCircle'
import { faMinusSquare as faMinusSquareProSolid } from '@fortawesome/pro-solid-svg-icons/faMinusSquare'
import { faMobileAlt as faMobileAltProSolid } from '@fortawesome/pro-solid-svg-icons/faMobileAlt'
import { faMoneyCheckAlt as faMoneyCheckAltProSolid } from '@fortawesome/pro-solid-svg-icons/faMoneyCheckAlt'
import { faMousePointer as faMousePointerProSolid } from '@fortawesome/pro-solid-svg-icons/faMousePointer'
import { faMusic as faMusicProSolid } from '@fortawesome/pro-solid-svg-icons/faMusic'
import { faNewspaper as faNewspaperProSolid } from '@fortawesome/pro-solid-svg-icons/faNewspaper'
import { faObjectUngroup as faObjectUngroupProSolid } from '@fortawesome/pro-solid-svg-icons/faObjectUngroup'
import { faPaintBrush as faPaintBrushProSolid } from '@fortawesome/pro-solid-svg-icons/faPaintBrush'
import { faPaperPlane as faPaperPlaneProSolid } from '@fortawesome/pro-solid-svg-icons/faPaperPlane'
import { faPaste as faPasteProSolid } from '@fortawesome/pro-solid-svg-icons/faPaste'
import { faPencil as faPencilProSolid } from '@fortawesome/pro-solid-svg-icons/faPencil'
import { faPepperHot as faPepperHotProSolid } from '@fortawesome/pro-solid-svg-icons/faPepperHot'
import { faPercent as faPercentProSolid } from '@fortawesome/pro-solid-svg-icons/faPercent'
import { faPhone as faPhoneProSolid } from '@fortawesome/pro-solid-svg-icons/faPhone'
import { faPlane as faPlaneProSolid } from '@fortawesome/pro-solid-svg-icons/faPlane'
import { faPlay as faPlayProSolid } from '@fortawesome/pro-solid-svg-icons/faPlay'
import { faPlusCircle as faPlusCircleProSolid } from '@fortawesome/pro-solid-svg-icons/faPlusCircle'
import { faPodcast as faPodcastProSolid } from '@fortawesome/pro-solid-svg-icons/faPodcast'
import { faPodium as faPodiumProSolid } from "@fortawesome/pro-solid-svg-icons/faPodium"
import { faPrint as faPrintProSolid } from '@fortawesome/pro-solid-svg-icons/faPrint'
import { faPumpkin as faPumpkinProSolid } from '@fortawesome/pro-solid-svg-icons/faPumpkin'
import { faPuzzlePiece as faPuzzlePieceProSolid } from '@fortawesome/pro-solid-svg-icons/faPuzzlePiece'
import { faQuestion as faQuestionProSolid } from '@fortawesome/pro-solid-svg-icons/faQuestion'
import { faQuestionCircle as faQuestionCircleProSolid } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle'
import { faQuoteRight as faQuoteRightProSolid } from '@fortawesome/pro-solid-svg-icons/faQuoteRight'
import { faRam as faRamProSolid } from '@fortawesome/pro-solid-svg-icons/faRam'
import { faReceipt as faReceiptProSolid } from '@fortawesome/pro-solid-svg-icons/faReceipt'
import { faRecycle as faRecycleProSolid } from '@fortawesome/pro-solid-svg-icons/faRecycle'
import { faReply as faReplyProSolid } from '@fortawesome/pro-solid-svg-icons/faReply'
import { faRetweet as faRetweetProSolid } from '@fortawesome/pro-solid-svg-icons/faRetweet'
import { faRss as faRssProSolid } from '@fortawesome/pro-solid-svg-icons/faRss'
import { faSave as faSaveProSolid } from '@fortawesome/pro-solid-svg-icons/faSave'
import { faSearch as faSearchProSolid } from '@fortawesome/pro-solid-svg-icons/faSearch'
import { faShareAlt as faShareAltProSolid } from '@fortawesome/pro-solid-svg-icons/faShareAlt'
import { faSignInAlt as faSignInAltProSolid } from '@fortawesome/pro-solid-svg-icons/faSignInAlt'
import { faSignLanguage as faSignLanguageProSolid } from '@fortawesome/pro-solid-svg-icons/faSignLanguage'
import { faSignOutAlt as faSignOutAltProSolid } from '@fortawesome/pro-solid-svg-icons/faSignOutAlt'
import { faSlash as faSlashProSolid } from '@fortawesome/pro-solid-svg-icons/faSlash'
import { faSmileBeam as faSmileBeamProSolid } from '@fortawesome/pro-solid-svg-icons/faSmileBeam'
import { faSort as faSortProSolid } from '@fortawesome/pro-solid-svg-icons/faSort'
import { faSortAmountDown as faSortAmountDownProSolid } from '@fortawesome/pro-solid-svg-icons/faSortAmountDown'
import { faSparkles as faSparklesProSolid } from '@fortawesome/pro-solid-svg-icons/faSparkles'
import { faStar as faStarProSolid } from '@fortawesome/pro-solid-svg-icons/faStar'
import { faStars as faStarsProSolid } from '@fortawesome/pro-solid-svg-icons/faStars'
import { faStickyNote as faStickyNoteProSolid } from '@fortawesome/pro-solid-svg-icons/faStickyNote'
import { faStreetView as faStreetViewProSolid } from '@fortawesome/pro-solid-svg-icons/faStreetView'
import { faSuitcase as faSuitcaseProSolid } from '@fortawesome/pro-solid-svg-icons/faSuitcase'
import { faSyncAlt as faSyncAltProSolid } from '@fortawesome/pro-solid-svg-icons/faSyncAlt'
import { faTabletAlt as faTabletAltProSolid } from '@fortawesome/pro-solid-svg-icons/faTabletAlt'
import { faTachometerAlt as faTachometerAltProSolid } from '@fortawesome/pro-solid-svg-icons/faTachometerAlt'
import { faTasksAlt as faTasksAltProSolid } from '@fortawesome/pro-solid-svg-icons/faTasksAlt'
import { faText as faTextProSolid } from '@fortawesome/pro-solid-svg-icons/faText'
import { faTh as faThProSolid } from '@fortawesome/pro-solid-svg-icons/faTh'
import { faThumbsDown as faThumbsDownProSolid } from '@fortawesome/pro-solid-svg-icons/faThumbsDown'
import { faThumbsUp as faThumbsUpProSolid } from '@fortawesome/pro-solid-svg-icons/faThumbsUp'
import { faThumbtack as faThumbtackProSolid } from '@fortawesome/pro-solid-svg-icons/faThumbtack'
import { faTimes as faTimesProSolid } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faToggleOff as faToggleOffProSolid } from '@fortawesome/pro-solid-svg-icons/faToggleOff'
import { faToggleOn as faToggleOnProSolid } from '@fortawesome/pro-solid-svg-icons/faToggleOn'
import { faToolbox as faToolboxProSolid } from '@fortawesome/pro-solid-svg-icons/faToolbox'
import { faTrashAlt as faTrashAltProSolid } from '@fortawesome/pro-solid-svg-icons/faTrashAlt'
import { faTree as faTreeProSolid } from '@fortawesome/pro-solid-svg-icons/faTree'
import { faTrophy as faTrophyProSolid } from '@fortawesome/pro-solid-svg-icons/faTrophy'
import { faTv as faTvProSolid } from '@fortawesome/pro-solid-svg-icons/faTv'
import { faUndo as faUndoProSolid } from '@fortawesome/pro-solid-svg-icons/faUndo'
import { faUniversity as faUniversityProSolid } from '@fortawesome/pro-solid-svg-icons/faUniversity'
import { faUser as faUserProSolid } from '@fortawesome/pro-solid-svg-icons/faUser'
import { faUserCheck as faUserCheckProSolid } from '@fortawesome/pro-solid-svg-icons/faUserCheck'
import { faUserCircle as faUserCircleProSolid } from '@fortawesome/pro-solid-svg-icons/faUserCircle'
import { faUserCog as faUserCogProSolid } from '@fortawesome/pro-solid-svg-icons/faUserCog'
import { faUserPlus as faUserPlusProSolid } from '@fortawesome/pro-solid-svg-icons/faUserPlus'
import { faUserTimes as faUserTimesProSolid } from '@fortawesome/pro-solid-svg-icons/faUserTimes'
import { faUsers as faUsersProSolid } from '@fortawesome/pro-solid-svg-icons/faUsers'
import { faUsersCog as faUsersCogProSolid } from '@fortawesome/pro-solid-svg-icons/faUsersCog'
import { faUtensils as faUtensilsProSolid } from '@fortawesome/pro-solid-svg-icons/faUtensils'
import { faUserTie as faUserTieProSolid } from '@fortawesome/pro-solid-svg-icons/faUserTie'
import { faVideo as faVideoProSolid } from '@fortawesome/pro-solid-svg-icons/faVideo'
import { faVolumeUp as faVolumeUpProSolid } from '@fortawesome/pro-solid-svg-icons/faVolumeUp'
import { faWifi as faWifiProSolid } from '@fortawesome/pro-solid-svg-icons/faWifi'
import { faWindowMaximize as faWindowMaximizeProSolid } from '@fortawesome/pro-solid-svg-icons/faWindowMaximize'
import { faWrench as faWrenchProSolid } from '@fortawesome/pro-solid-svg-icons/faWrench'
import { faShieldAlt as faShieldAltProSolid } from '@fortawesome/pro-solid-svg-icons/faShieldAlt'
import { faTasks as faTasksProSolid } from '@fortawesome/pro-solid-svg-icons/faTasks'
import { faClone as faCloneProSolid } from '@fortawesome/pro-solid-svg-icons/faClone'
import { faBell as faBellProSolid } from '@fortawesome/pro-solid-svg-icons/faBell'

// ProLight Icons (prefixed with "fal")
import { faAddressBook as faAddressBookProLight } from '@fortawesome/pro-light-svg-icons/faAddressBook'
import { faAddressCard as faAddressCardProLight } from '@fortawesome/pro-light-svg-icons/faAddressCard'
import { faAngleDown as faAngleDownProLight } from '@fortawesome/pro-light-svg-icons/faAngleDown'
import { faAngleUp as faAngleUpProLight } from '@fortawesome/pro-light-svg-icons/faAngleUp'
import { faArrowAltCircleDown as faArrowAltCircleDownProLight } from '@fortawesome/pro-light-svg-icons/faArrowAltCircleDown'
import { faArrowAltCircleRight as faArrowAltCircleRightProLight } from '@fortawesome/pro-light-svg-icons/faArrowAltCircleRight'
import { faArrowAltCircleUp as faArrowAltCircleUpProLight } from '@fortawesome/pro-light-svg-icons/faArrowAltCircleUp'
import { faArrowCircleDown as faArrowCircleDownProLight } from '@fortawesome/pro-light-svg-icons/faArrowCircleDown'
import { faArrowCircleRight as faArrowCircleRightProLight } from '@fortawesome/pro-light-svg-icons/faArrowCircleRight'
import { faArrowCircleUp as faArrowCircleUpProLight } from '@fortawesome/pro-light-svg-icons/faArrowCircleUp'
import { faArrowDown as faArrowDownProLight } from '@fortawesome/pro-light-svg-icons/faArrowDown'
import { faArrowLeft as faArrowLeftProLight } from '@fortawesome/pro-light-svg-icons/faArrowLeft'
import { faArrowRight as faArrowRightProLight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import { faArrowUp as faArrowUpProLight } from '@fortawesome/pro-light-svg-icons/faArrowUp'
import { faBallotCheck as faBallotCheckProLight } from '@fortawesome/pro-light-svg-icons/faBallotCheck'
import { faBook as faBookProLight } from '@fortawesome/pro-light-svg-icons/faBook'
import { faBuilding as faBuildingProLight } from '@fortawesome/pro-light-svg-icons/faBuilding'
import { faBullhorn as faBullhornProLight } from '@fortawesome/pro-light-svg-icons/faBullhorn'
import { faBars as faBarsProLight } from '@fortawesome/pro-light-svg-icons/faBars'
import { faCalendarAlt as faCalendarAltProLight } from '@fortawesome/pro-light-svg-icons/faCalendarAlt'
import { faCalendarCheck as faCalendarCheckProLight } from '@fortawesome/pro-light-svg-icons/faCalendarCheck'
import { faCheck as faCheckProLight } from '@fortawesome/pro-light-svg-icons/faCheck'
import { faChild as faChildProLight } from '@fortawesome/pro-light-svg-icons/faChild'
import { faCircle as faCircleProLight } from '@fortawesome/pro-light-svg-icons/faCircle'
import { faClock as faClockProLight } from '@fortawesome/pro-light-svg-icons/faClock'
import { faCloudDownload as faCloudDownloadProLight } from '@fortawesome/pro-light-svg-icons/faCloudDownload'
import { faCloudDownloadAlt as faCloudDownloadAltProLight } from '@fortawesome/pro-light-svg-icons/faCloudDownloadAlt'
import { faCode as faCodeProLight } from '@fortawesome/pro-light-svg-icons/faCode'
import { faColumns as faColumnsProLight } from '@fortawesome/pro-light-svg-icons/faColumns'
import { faComment as faCommentProLight } from '@fortawesome/pro-light-svg-icons/faComment'
import { faCommentEdit as faCommentEditProLight } from '@fortawesome/pro-light-svg-icons/faCommentEdit'
import { faComments as faCommentsProLight } from '@fortawesome/pro-light-svg-icons/faComments'
import { faCompass as faCompassProLight } from '@fortawesome/pro-light-svg-icons/faCompass'
import { faCopy as faCopyProLight } from '@fortawesome/pro-light-svg-icons/faCopy'
import { faCreditCard as faCreditCardProLight } from '@fortawesome/pro-light-svg-icons/faCreditCard'
import { faCubes as faCubesProLight } from '@fortawesome/pro-light-svg-icons/faCubes'
import { faDollarSign as faDollarSignProLight } from '@fortawesome/pro-light-svg-icons/faDollarSign'
import { faDrawSquare as faDrawSquareProLight } from '@fortawesome/pro-light-svg-icons/faDrawSquare'
import { faEdit as faEditProLight } from '@fortawesome/pro-light-svg-icons/faEdit'
import { faEmptySet as faEmptySetProLight } from "@fortawesome/pro-light-svg-icons/faEmptySet"
import { faEnvelope as faEnvelopeProLight } from '@fortawesome/pro-light-svg-icons/faEnvelope'
import { faEnvelopeOpen as faEnvelopeOpenProLight } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpen'
import { faEnvelopeOpenText as faEnvelopeOpenTextProLight } from '@fortawesome/pro-light-svg-icons/faEnvelopeOpenText'
import { faExclamationCircle as faExclamationCircleProLight } from '@fortawesome/pro-light-svg-icons/faExclamationCircle'
import { faExclamationTriangle as faExclamationTriangleProLight } from '@fortawesome/pro-light-svg-icons/faExclamationTriangle'
import { faEye as faEyeProLight } from '@fortawesome/pro-light-svg-icons/faEye'
import { faFile as faFileProLight } from '@fortawesome/pro-light-svg-icons/faFile'
import { faFileAlt as faFileAltProLight } from '@fortawesome/pro-light-svg-icons/faFileAlt'
import { faFileArchive as faFileArchiveProLight } from '@fortawesome/pro-light-svg-icons/faFileArchive'
import { faFileAudio as faFileAudioProLight } from '@fortawesome/pro-light-svg-icons/faFileAudio'
import { faFileCsv as faFileCsvProLight } from '@fortawesome/pro-light-svg-icons/faFileCsv'
import { faFileEdit as faFileEditProLight } from '@fortawesome/pro-light-svg-icons/faFileEdit'
import { faFileExcel as faFileExcelProLight } from '@fortawesome/pro-light-svg-icons/faFileExcel'
import { faFileImage as faFileImageProLight } from '@fortawesome/pro-light-svg-icons/faFileImage'
import { faFileInvoiceDollar as faFileInvoiceDollarProLight } from '@fortawesome/pro-light-svg-icons/faFileInvoiceDollar'
import { faFilePdf as faFilePdfProLight } from '@fortawesome/pro-light-svg-icons/faFilePdf'
import { faFilePowerpoint as faFilePowerpointProLight } from '@fortawesome/pro-light-svg-icons/faFilePowerpoint'
import { faFileVideo as faFileVideoProLight } from '@fortawesome/pro-light-svg-icons/faFileVideo'
import { faFileWord as faFileWordProLight } from '@fortawesome/pro-light-svg-icons/faFileWord'
import { faFilter as faFilterProLight } from '@fortawesome/pro-light-svg-icons/faFilter'
import { faFlagAlt as faFlagAltProLight } from '@fortawesome/pro-light-svg-icons/faFlagAlt'
import { faFolder as faFolderProLight } from '@fortawesome/pro-light-svg-icons/faFolder'
import { faFolderOpen as faFolderOpenProLight } from '@fortawesome/pro-light-svg-icons/faFolderOpen'
import { faFolders as faFoldersProLight } from '@fortawesome/pro-light-svg-icons/faFolders'
import { faGavel as faGavelProLight } from '@fortawesome/pro-light-svg-icons/faGavel'
import { faGlobe as faGlobeProLight } from '@fortawesome/pro-light-svg-icons/faGlobe'
import { faGlobeAmericas as faGlobeAmericasProLight } from '@fortawesome/pro-light-svg-icons/faGlobeAmericas'
import { faGripLines as faGripLinesProLight } from '@fortawesome/pro-light-svg-icons/faGripLines'
import { faHandshake as faHandshakeProLight } from '@fortawesome/pro-light-svg-icons/faHandshake'
import { faHorizontalRule as faHorizontalRuleProLight } from '@fortawesome/pro-light-svg-icons/faHorizontalRule'
import { faInfoCircle as faInfoCircleProLight } from '@fortawesome/pro-light-svg-icons/faInfoCircle'
import { faIslandTropical as faIslandTropicalProLight } from '@fortawesome/pro-light-svg-icons/faIslandTropical'
import { faLayerGroup as faLayerGroupProLight } from '@fortawesome/pro-light-svg-icons/faLayerGroup'
import { faLevelUp as faLevelUpProLight } from '@fortawesome/pro-light-svg-icons/faLevelUp'
import { faLightbulb as faLightbulbProLight } from '@fortawesome/pro-light-svg-icons/faLightbulb'
import { faListUl as faListUlProLight } from '@fortawesome/pro-light-svg-icons/faListUl'
import { faLink as faLinkProLight } from '@fortawesome/pro-light-svg-icons/faLink'
import { faLocation as faLocationProLight } from '@fortawesome/pro-light-svg-icons/faLocation'
import { faLock as faLockProLight } from '@fortawesome/pro-light-svg-icons/faLock'
import { faLockAlt as faLockAltProLight } from '@fortawesome/pro-light-svg-icons/faLockAlt'
import { faLockOpen as faLockOpenProLight } from '@fortawesome/pro-light-svg-icons/faLockOpen'
import { faLongArrowDown as faLongArrowDownProLight } from '@fortawesome/pro-light-svg-icons/faLongArrowDown'
import { faLongArrowLeft as faLongArrowLeftProLight } from '@fortawesome/pro-light-svg-icons/faLongArrowLeft'
import { faLongArrowRight as faLongArrowRightProLight } from '@fortawesome/pro-light-svg-icons/faLongArrowRight'
import { faLongArrowUp as faLongArrowUpProLight } from '@fortawesome/pro-light-svg-icons/faLongArrowUp'
import { faMap as faMapProLight } from '@fortawesome/pro-light-svg-icons/faMap'
import { faMapMarker as faMapMarkerProLight } from '@fortawesome/pro-light-svg-icons/faMapMarker'
import { faMapMarkedAlt as faMapMarkedAltProLight } from '@fortawesome/pro-light-svg-icons/faMapMarkedAlt'
import { faMapPin as faMapPinProLight } from '@fortawesome/pro-light-svg-icons/faMapPin'
import { faMapSigns as faMapSignsProLight } from '@fortawesome/pro-light-svg-icons/faMapSigns'
import { faMicrophone as faMicrophoneProLight } from '@fortawesome/pro-light-svg-icons/faMicrophone'
import { faMinus as faMinusProLight } from '@fortawesome/pro-light-svg-icons/faMinus'
import { faMinusCircle as faMinusCircleProLight } from '@fortawesome/pro-light-svg-icons/faMinusCircle'
import { faMoneyBillAlt as faMoneyBillAltProLight } from '@fortawesome/pro-light-svg-icons/faMoneyBillAlt'
import { faMoneyBillWave as faMoneyBillWaveProLight } from '@fortawesome/pro-light-svg-icons/faMoneyBillWave'
import { faMoneyCheckAlt as faMoneyCheckAltProLight } from '@fortawesome/pro-light-svg-icons/faMoneyCheckAlt'
import { faMoneyCheckEditAlt as faMoneyCheckEditAltProLight } from '@fortawesome/pro-light-svg-icons/faMoneyCheckEditAlt'
import { faNewspaper as faNewspaperProLight } from '@fortawesome/pro-light-svg-icons/faNewspaper'
import { faObjectUngroup as faObjectUngroupProLight } from '@fortawesome/pro-light-svg-icons/faObjectUngroup'
import { faPaperclip as faPaperclipProLight } from '@fortawesome/pro-light-svg-icons/faPaperclip'
import { faPencil as faPencilProLight } from '@fortawesome/pro-light-svg-icons/faPencil'
import { faPencilAlt as faPencilAltProLight } from '@fortawesome/pro-light-svg-icons/faPencilAlt'
import { faPhone as faPhoneProLight } from '@fortawesome/pro-light-svg-icons/faPhone'
import { faPlus as faPlusProLight } from '@fortawesome/pro-light-svg-icons/faPlus'
import { faPlusCircle as faPlusCircleProLight } from '@fortawesome/pro-light-svg-icons/faPlusCircle'
import { faPodium as faPodiumProLight } from "@fortawesome/pro-light-svg-icons/faPodium"
import { faRandom as faRandomProLight } from '@fortawesome/pro-light-svg-icons/faRandom'
import { faReceipt as faReceiptProLight } from '@fortawesome/pro-light-svg-icons/faReceipt'
import { faRectangleWide as faRectangleWideProLight } from '@fortawesome/pro-light-svg-icons/faRectangleWide'
import { faRss as faRssProLight } from '@fortawesome/pro-light-svg-icons/faRss'
import { faSave as faSaveProLight } from '@fortawesome/pro-light-svg-icons/faSave'
import { faSearch as faSearchProLight } from '@fortawesome/pro-light-svg-icons/faSearch'
import { faShare as faShareProLight } from '@fortawesome/pro-light-svg-icons/faShare'
import { faSlash as faSlashProLight } from '@fortawesome/pro-light-svg-icons/faSlash'
import { faSortAlt as faSortAltProLight } from '@fortawesome/pro-light-svg-icons/faSortAlt'
import { faSortAmountDown as faSortAmountDownProLight } from '@fortawesome/pro-light-svg-icons/faSortAmountDown'
import { faSortAmountUp as faSortAmountUpProLight } from '@fortawesome/pro-light-svg-icons/faSortAmountUp'
import { faSparkles as faSparklesProLight } from '@fortawesome/pro-light-svg-icons/faSparkles'
import { faSpinner as faSpinnerLight } from '@fortawesome/pro-light-svg-icons/faSpinner'
import { faSquare as faSquareProLight } from '@fortawesome/pro-light-svg-icons/faSquare'
import { faStar as faStarProLight } from '@fortawesome/pro-light-svg-icons/faStar'
import { faStickyNote as faStickyNoteProLight } from '@fortawesome/pro-light-svg-icons/faStickyNote'
import { faSuitcase as faSuitcaseProLight } from '@fortawesome/pro-light-svg-icons/faSuitcase'
import { faSmileBeam as faSmileBeamProLight } from '@fortawesome/pro-light-svg-icons/faSmileBeam'
import { faTable as faTableProLight } from '@fortawesome/pro-light-svg-icons/faTable'
import { faTachometerAlt as faTachometerAltProLight } from '@fortawesome/pro-light-svg-icons/faTachometerAlt'
import { faTasksAlt as faTasksAltProLight } from '@fortawesome/pro-light-svg-icons/faTasksAlt'
import { faTextSize as faTextSizeProLight } from '@fortawesome/pro-light-svg-icons/faTextSize'
import { faTextHeight as faTextHeightProLight } from '@fortawesome/pro-light-svg-icons/faTextHeight'
import { faThumbsDown as faThumbsDownProLight } from '@fortawesome/pro-light-svg-icons/faThumbsDown'
import { faThumbsUp as faThumbsUpProLight } from '@fortawesome/pro-light-svg-icons/faThumbsUp'
import { faThumbtack as faThumbtackProLight } from '@fortawesome/pro-light-svg-icons/faThumbtack'
import { faTimes as faTimesProLight } from '@fortawesome/pro-light-svg-icons/faTimes'
import { faTimesCircle as faTimesCircleProLight } from '@fortawesome/pro-light-svg-icons/faTimesCircle'
import { faUsdCircle as faUsdCircleProLight } from '@fortawesome/pro-light-svg-icons/faUsdCircle'
import { faUser as faUserProLight } from '@fortawesome/pro-light-svg-icons/faUser'
import { faUserCircle as faUserCircleProLight } from '@fortawesome/pro-light-svg-icons/faUserCircle'
import { faUserCog as faUserCogProLight } from '@fortawesome/pro-light-svg-icons/faUserCog'
import { faUserFriends as faUserFriendsProLight } from '@fortawesome/pro-light-svg-icons/faUserFriends'
import { faUserLock as faUserLockProLight } from '@fortawesome/pro-light-svg-icons/faUserLock'
import { faUserPlus as faUserPlusProLight } from '@fortawesome/pro-light-svg-icons/faUserPlus'
import { faUsers as faUsersProLight } from '@fortawesome/pro-light-svg-icons/faUsers'
import { faUsersCog as faUsersCogProLight } from '@fortawesome/pro-light-svg-icons/faUsersCog'
import { faAlignJustify as faAlignJustifyProLight } from '@fortawesome/pro-light-svg-icons/faAlignJustify'
import { faUserTie as faUserTieProLight } from '@fortawesome/pro-light-svg-icons/faUserTie'
import { faVideo as faVideoProLight } from '@fortawesome/pro-light-svg-icons/faVideo'
import { faTasks as faTasksProLight } from '@fortawesome/pro-light-svg-icons/faTasks'
import { faClone as faCloneProLight } from '@fortawesome/pro-light-svg-icons/faClone'
import { faBell as faBellProLight } from '@fortawesome/pro-light-svg-icons/faBell'

// ProDuotone Icons (prefixed with "fad")
import { faArchive as faArchiveProDuotone, faShield as faShieldProDuotone } from '@fortawesome/pro-duotone-svg-icons'
import { faAddressBook as faAddressBookProDuotone } from '@fortawesome/pro-duotone-svg-icons/faAddressBook'
import { faAddressCard as faAddressCardProDuotone } from '@fortawesome/pro-duotone-svg-icons/faAddressCard'
import { faAlarmClock as faAlarmClockProDuotone } from '@fortawesome/pro-duotone-svg-icons/faAlarmClock'
import { faAnalytics as faAnalyticsProDuotone } from '@fortawesome/pro-duotone-svg-icons/faAnalytics'
import { faArrowDown as faArrowDownProDuotone } from '@fortawesome/pro-duotone-svg-icons/faArrowDown'
import { faArrowLeft as faArrowLeftProDuotone } from '@fortawesome/pro-duotone-svg-icons/faArrowLeft'
import { faArrowRight as faArrowRightProDuotone } from '@fortawesome/pro-duotone-svg-icons/faArrowRight'
import { faArrowToBottom as faArrowToBottomProDuotone } from '@fortawesome/pro-duotone-svg-icons/faArrowToBottom'
import { faArrowUp as faArrowUpProDuotone } from '@fortawesome/pro-duotone-svg-icons/faArrowUp'
import { faAtlas as faAtlasProDuotone } from '@fortawesome/pro-duotone-svg-icons/faAtlas'
import { faBellExclamation as faBellExclamationProDuotone } from '@fortawesome/pro-duotone-svg-icons/faBellExclamation'
import { faBookReader as faBookReaderProDuotone } from '@fortawesome/pro-duotone-svg-icons/faBookReader'
import { faBrowser as faBrowserProDuotone } from '@fortawesome/pro-duotone-svg-icons/faBrowser'
import { faBug as faBugProDuotone } from '@fortawesome/pro-duotone-svg-icons/faBug'
import { faBuilding as faBuildingProDuotone } from '@fortawesome/pro-duotone-svg-icons/faBuilding'
import { faBullhorn as faBullhornProDuotone } from '@fortawesome/pro-duotone-svg-icons/faBullhorn'
import { faBullseyeArrow as faBullseyeArrowProDuotone } from '@fortawesome/pro-duotone-svg-icons/faBullseyeArrow'
import { faCalendarCheck as faCalendarCheckProDuotone } from '@fortawesome/pro-duotone-svg-icons/faCalendarCheck'
import { faChartBar as faChartBarProDuotone } from '@fortawesome/pro-duotone-svg-icons/faChartBar'
import { faChartLine as faChartLineProDuotone } from '@fortawesome/pro-duotone-svg-icons/faChartLine'
import { faChartNetwork as faChartNetworkProDuotone } from '@fortawesome/pro-duotone-svg-icons/faChartNetwork'
import { faCheckCircle as faCheckCircleProDuotone } from '@fortawesome/pro-duotone-svg-icons/faCheckCircle'
import { faCheckSquare as faCheckSquareProDuotone } from '@fortawesome/pro-duotone-svg-icons/faCheckSquare'
import { faCheeseSwiss as faCheeseSwissProDuotone } from '@fortawesome/pro-duotone-svg-icons/faCheeseSwiss'
import { faCloudDownloadAlt as faCloudDownloadAltProDuotone } from '@fortawesome/pro-duotone-svg-icons/faCloudDownloadAlt'
import { faCog as faCogProDuotone } from '@fortawesome/pro-duotone-svg-icons/faCog'
import { faComment as faCommentProDuotone } from '@fortawesome/pro-duotone-svg-icons/faComment'
import { faCommentAltLines as faCommentAltLinesProDuotone } from '@fortawesome/pro-duotone-svg-icons/faCommentAltLines'
import { faCommentDots as faCommentDotsProDuotone } from '@fortawesome/pro-duotone-svg-icons/faCommentDots'
import { faCommentEdit as faCommentEditProDuotone } from '@fortawesome/pro-duotone-svg-icons/faCommentEdit'
import { faCompass as faCompassProDuotone } from '@fortawesome/pro-duotone-svg-icons/faCompass'
import { faCopy as faCopyProDuotone } from '@fortawesome/pro-duotone-svg-icons/faCopy'
import { faDownload as faDownloadProDuotone } from '@fortawesome/pro-duotone-svg-icons/faDownload'
import { faEdit as faEditProDuotone } from '@fortawesome/pro-duotone-svg-icons/faEdit'
import { faEnvelope as faEnvelopeProDuotone } from '@fortawesome/pro-duotone-svg-icons/faEnvelope'
import { faEnvelopeOpen as faEnvelopeOpenProDuotone } from '@fortawesome/pro-duotone-svg-icons/faEnvelopeOpen'
import { faEnvelopeOpenText as faEnvelopeOpenTextProDuotone } from '@fortawesome/pro-duotone-svg-icons/faEnvelopeOpenText'
import { faExclamationTriangle as faExclamationTriangleProDuotone } from '@fortawesome/pro-duotone-svg-icons/faExclamationTriangle'
import { faEye as faEyeProDuotone } from '@fortawesome/pro-duotone-svg-icons/faEye'
import { faFileAlt as faFileAltProDuotone } from '@fortawesome/pro-duotone-svg-icons/faFileAlt'
import { faFileChartLine as faFileChartLineProDuotone } from '@fortawesome/pro-duotone-svg-icons/faFileChartLine'
import { faFileChartPie as faFileChartPieProDuotone } from '@fortawesome/pro-duotone-svg-icons/faFileChartPie'
import { faFileInvoiceDollar as faFileInvoiceDollarProDuotone } from '@fortawesome/pro-duotone-svg-icons/faFileInvoiceDollar'
import { faFlag as faFlagProDuotone } from '@fortawesome/pro-duotone-svg-icons/faFlag'
import { faFlagCheckered as faFlagCheckeredProDuotone } from '@fortawesome/pro-duotone-svg-icons/faFlagCheckered'
import { faGlobe as faGlobeProDuotone } from '@fortawesome/pro-duotone-svg-icons/faGlobe'
import { faGraduationCap as faGraduationCapProDuotone } from '@fortawesome/pro-duotone-svg-icons/faGraduationCap'
import { faHamburger as faHamburgerProDuotone } from '@fortawesome/pro-duotone-svg-icons/faHamburger'
import { faHandHoldingUsd as faHandHoldingUsdProDuotone } from '@fortawesome/pro-duotone-svg-icons/faHandHoldingUsd'
import { faHandshake as faHandshakeProDuotone } from '@fortawesome/pro-duotone-svg-icons/faHandshake'
import { faHourglass as faHourglassProDuotone } from '@fortawesome/pro-duotone-svg-icons/faHourglass'
import { faKeySkeleton as faKeySkeletonProDuotone } from '@fortawesome/pro-duotone-svg-icons/faKeySkeleton'
import { faLandmark as faLandmarkProDuotone } from '@fortawesome/pro-duotone-svg-icons/faLandmark'
import { faList as faListProDuotone } from '@fortawesome/pro-duotone-svg-icons/faList'
import { faListAlt as faListAltProDuotone } from '@fortawesome/pro-duotone-svg-icons/faListAlt'
import { faListUl as faListUlProDuotone } from '@fortawesome/pro-duotone-svg-icons/faListUl'
import { faLockAlt as faLockAltProDuotone } from '@fortawesome/pro-duotone-svg-icons/faLockAlt'
import { faMap as faMapProDuotone } from '@fortawesome/pro-duotone-svg-icons/faMap'
import { faMapMarkedAlt as faMapMarkedAltProDuotone } from '@fortawesome/pro-duotone-svg-icons/faMapMarkedAlt'
import { faMicrophone as faMicrophoneProDuotone } from '@fortawesome/pro-duotone-svg-icons/faMicrophone'
import { faMobile as faMobileProDuotone } from '@fortawesome/pro-duotone-svg-icons/faMobile'
import { faMobileAlt as faMobileAltProDuotone } from '@fortawesome/pro-duotone-svg-icons/faMobileAlt'
import { faMonument as faMonumentProDuotone } from '@fortawesome/pro-duotone-svg-icons/faMonument'
import { faObjectUngroup as faObjectUngroupProDuotone } from '@fortawesome/pro-duotone-svg-icons/faObjectUngroup'
import { faPaintBrushAlt as faPaintBrushAltProDuotone } from '@fortawesome/pro-duotone-svg-icons/faPaintBrushAlt'
import { faPaintRoller as faPaintRollerProDuotone } from '@fortawesome/pro-duotone-svg-icons/faPaintRoller'
import { faPalette as faPaletteProDuotone } from '@fortawesome/pro-duotone-svg-icons/faPalette'
import { faPaperPlane as faPaperPlaneProDuotone } from '@fortawesome/pro-duotone-svg-icons/faPaperPlane'
import { faPenSquare as faPenSquareProDuotone } from '@fortawesome/pro-duotone-svg-icons/faPenSquare'
import { faPencil as faPencilProDuotone } from '@fortawesome/pro-duotone-svg-icons/faPencil'
import { faPiggyBank as faPiggyBankProDuotone } from '@fortawesome/pro-duotone-svg-icons/faPiggyBank'
import { faPodium as faPodiumProDuotone } from '@fortawesome/pro-duotone-svg-icons/faPodium'
import { faPrint as faPrintProDuotone } from '@fortawesome/pro-duotone-svg-icons/faPrint'
import { faRecycle as faRecycleProDuotone } from '@fortawesome/pro-duotone-svg-icons/faRecycle'
import { faRss as faRssProDuotone } from '@fortawesome/pro-duotone-svg-icons/faRss'
import { faSearch as faSearchProDuotone } from '@fortawesome/pro-duotone-svg-icons/faSearch'
import { faShareAll as faShareAllProDuotone } from '@fortawesome/pro-duotone-svg-icons/faShareAll'
import { faSlidersH as faSlidersHProDuotone } from '@fortawesome/pro-duotone-svg-icons/faSlidersH'
import { faSlidersHSquare as faSlidersHSquareProDuotone } from '@fortawesome/pro-duotone-svg-icons/faSlidersHSquare'
import { faSortAmountDown as faSortAmountDownProDuotone } from '@fortawesome/pro-duotone-svg-icons/faSortAmountDown'
import { faSortAmountDownAlt as faSortAmountDownAltProDuotone } from '@fortawesome/pro-duotone-svg-icons/faSortAmountDownAlt'
import { faStar as faStarProDuotone } from '@fortawesome/pro-duotone-svg-icons/faStar'
import { faTable as faTableProDuotone } from '@fortawesome/pro-duotone-svg-icons/faTable'
import { faTachometerAlt as faTachometerAltProDuotone } from '@fortawesome/pro-duotone-svg-icons/faTachometerAlt'
import { faTachometerAltFast as faTachometerAltFastProDuotone } from '@fortawesome/pro-duotone-svg-icons/faTachometerAltFast'
import { faTags as faTagsProDuotone } from '@fortawesome/pro-duotone-svg-icons/faTags'
import { faTasks as faTasksProDuotone } from '@fortawesome/pro-duotone-svg-icons/faTasks'
import { faThList as faThListProDuotone } from '@fortawesome/pro-duotone-svg-icons/faThList'
import { faThumbsUp as faThumbsUpProDuotone } from '@fortawesome/pro-duotone-svg-icons/faThumbsUp'
import { faThumbtack as faThumbtackProDuotone } from '@fortawesome/pro-duotone-svg-icons/faThumbtack'
import { faTimesOctagon as faTimesOctagonDuotone } from '@fortawesome/pro-duotone-svg-icons/faTimesOctagon'
import { faTrophyAlt as faTrophyAltProDuotone } from '@fortawesome/pro-duotone-svg-icons/faTrophyAlt'
import { faUpload as faUploadProDuotone } from '@fortawesome/pro-duotone-svg-icons/faUpload'
import { faUserAlt as faUserAltProDuotone } from '@fortawesome/pro-duotone-svg-icons/faUserAlt'
import { faUserCheck as faUserCheckProDuotone } from '@fortawesome/pro-duotone-svg-icons/faUserCheck'
import { faUserCog as faUserCogProDuotone } from '@fortawesome/pro-duotone-svg-icons/faUserCog'
import { faUserSecret as faUserSecretProDuotone } from '@fortawesome/pro-duotone-svg-icons/faUserSecret'
import { faUsers as faUsersProDuotone } from '@fortawesome/pro-duotone-svg-icons/faUsers'
import { faUsersClass as faUsersClassProDuotone } from '@fortawesome/pro-duotone-svg-icons/faUsersClass'
import { faUsersCog as faUsersCogProDuotone } from '@fortawesome/pro-duotone-svg-icons/faUsersCog'
import { faBell as faBellProDuotone } from '@fortawesome/pro-duotone-svg-icons/faBell'

// Brand Icons (prefixed with "fab")
import { faFacebookSquare as faFacebookSquareBrand, faInstagramSquare as faInstagramSquareBrand, faLinkedin as faLinkedInBrand, faTwitterSquare as faTwitterSquareBrand, faYoutubeSquare as faYoutubeSquareBrand } from "@fortawesome/free-brands-svg-icons"
import { faAdn as faAdnBrand } from '@fortawesome/free-brands-svg-icons/faAdn'
import { faAmazon as faAmazonBrand } from '@fortawesome/free-brands-svg-icons/faAmazon'
import { faAndroid as faAndroidBrand } from '@fortawesome/free-brands-svg-icons/faAndroid'
import { faApple as faAppleBrand } from '@fortawesome/free-brands-svg-icons/faApple'
import { faBuysellads as faBuyselladsBrand } from '@fortawesome/free-brands-svg-icons/faBuysellads'
import { faCcStripe as faCcStripeBrand } from '@fortawesome/free-brands-svg-icons/faCcStripe'
import { faConnectdevelop as faConnectdevelopBrand } from '@fortawesome/free-brands-svg-icons/faConnectdevelop'
import { faFacebook as faFacebookBrand } from '@fortawesome/free-brands-svg-icons/faFacebook'
import { faFacebookF as faFacebookFBrand } from '@fortawesome/free-brands-svg-icons/faFacebookF'
import { faGoogle as faGoogleBrand } from '@fortawesome/free-brands-svg-icons/faGoogle'
import { faInstagram as faInstagramBrand } from '@fortawesome/free-brands-svg-icons/faInstagram'
import { faLinkedinIn as faLinkedinInBrand } from '@fortawesome/free-brands-svg-icons/faLinkedinIn'
import { faMedium as faMediumBrand } from '@fortawesome/free-brands-svg-icons/faMedium'
import { faMediumM as faMediumMBrand } from '@fortawesome/free-brands-svg-icons/faMediumM'
import { faMicrosoft as faMicrosoftBrand } from '@fortawesome/free-brands-svg-icons/faMicrosoft'
import { faSlideshare as faSlideshareBrand } from '@fortawesome/free-brands-svg-icons/faSlideshare'
import { faStripe as faStripeBrand } from '@fortawesome/free-brands-svg-icons/faStripe'
import { faTwitter as faTwitterBrand } from '@fortawesome/free-brands-svg-icons/faTwitter'
import { faYahoo as faYahooBrand } from '@fortawesome/free-brands-svg-icons/faYahoo'
import { faYoutube as faYoutubeBrand } from '@fortawesome/free-brands-svg-icons/faYoutube'

// CUSTOM ICONS
const faDashboard = {
    prefix: 'q',
    iconName: 'dashboard',
    icon: [
        45,
        46,
        [],
        "f0000",
        "M42.426 34a2.4 2.4 0 0 1 2.4 2.4v6.8a2.4 2.4 0 0 1-2.4 2.4h-6.554a2.4 2.4 0 0 1-2.4-2.4v-6.8a2.4 2.4 0 0 1 2.4-2.4h6.554zm-14.29-.2a2.4 2.4 0 0 1 2.4 2.4V43a2.4 2.4 0 0 1-2.4 2.4H2.791a2.4 2.4 0 0 1-2.4-2.4v-6.8a2.4 2.4 0 0 1 2.4-2.4h25.345zM8.953 14.6a2.4 2.4 0 0 1 2.4 2.4v11.6a2.4 2.4 0 0 1-2.4 2.4H2.4A2.4 2.4 0 0 1 0 28.6V17a2.4 2.4 0 0 1 2.4-2.4h6.553zm33.277 0a2.4 2.4 0 0 1 2.4 2.4v11.6a2.4 2.4 0 0 1-2.4 2.4h-6.553a2.4 2.4 0 0 1-2.4-2.4V17a2.4 2.4 0 0 1 2.4-2.4h6.553zm-14.094 0a2.4 2.4 0 0 1 2.4 2.4v11.6a2.4 2.4 0 0 1-2.4 2.4h-11.25a2.4 2.4 0 0 1-2.4-2.4V17a2.4 2.4 0 0 1 2.4-2.4h11.25zM9.15 0a2.4 2.4 0 0 1 2.4 2.4v6.8a2.4 2.4 0 0 1-2.4 2.4H2.596a2.4 2.4 0 0 1-2.4-2.4V2.4a2.4 2.4 0 0 1 2.4-2.4h6.553zm33.08 0a2.4 2.4 0 0 1 2.4 2.4v6.8a2.4 2.4 0 0 1-2.4 2.4H16.886a2.4 2.4 0 0 1-2.4-2.4V2.4a2.4 2.4 0 0 1 2.4-2.4H42.23z"
    ]
}

const faDashboardSmall = {
    prefix: 'q',
    iconName: 'dashboard-small',
    icon: [
        24,
        24,
        [],
        "f0001",
        "M15 18a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h14zm8 0a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4zM5 8a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h4zm18 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h4zm-8 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h6zM5 0a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h4zm18 0a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14z"
    ]
}

const faDragHandle = {
    prefix: 'q',
    iconName: 'drag-handle',
    icon: [
        30,
        30,
        [],
        "f0002",
        "M1.521 30h26.958c.84 0 1.521-.681 1.521-1.521V1.521A1.521 1.521 0 0 0 27.403.445L.445 27.403A1.521 1.521 0 0 0 1.521 30z"
    ]
}

const faEUStars = {
    prefix: 'q',
    iconName: 'eu-stars',
    icon: [
        30,
        30,
        [],
        "f0003",
        `M 22.24,26.74
           C 22.24,26.74 23.56,25.81 23.56,25.81
             23.56,25.81 21.93,25.81 21.93,25.81
             21.93,25.81 21.39,24.21 21.39,24.21
             21.39,24.21 20.87,25.81 20.87,25.81
             20.87,25.81 19.30,25.81 19.30,25.81
             19.30,25.81 20.57,26.71 20.57,26.71
             20.57,26.71 20.06,28.27 20.06,28.27
             20.06,28.27 21.42,27.30 21.42,27.30
             21.42,27.30 22.74,28.23 22.74,28.23
             22.74,28.23 22.24,26.74 22.24,26.74 Z
           M 26.90,21.92
           C 26.90,21.92 28.22,20.99 28.22,20.99
             28.22,20.99 26.59,20.99 26.59,20.99
             26.59,20.99 26.06,19.39 26.06,19.39
             26.06,19.39 25.53,20.99 25.53,20.99
             25.53,20.99 23.96,20.99 23.96,20.99
             23.96,20.99 25.24,21.89 25.24,21.89
             25.24,21.89 24.73,23.45 24.73,23.45
             24.73,23.45 26.08,22.49 26.08,22.49
             26.08,22.49 27.40,23.41 27.40,23.41
             27.40,23.41 26.90,21.92 26.90,21.92 Z
           M 22.24,4.31
           C 22.24,4.31 23.56,3.38 23.56,3.38
             23.56,3.38 21.93,3.38 21.93,3.38
             21.93,3.38 21.39,1.78 21.39,1.78
             21.39,1.78 20.87,3.38 20.87,3.38
             20.87,3.38 19.30,3.38 19.30,3.38
             19.30,3.38 20.57,4.28 20.57,4.28
             20.57,4.28 20.06,5.84 20.06,5.84
             20.06,5.84 21.42,4.87 21.42,4.87
             21.42,4.87 22.74,5.80 22.74,5.80
             22.74,5.80 22.24,4.31 22.24,4.31 Z
           M 26.90,9.03
           C 26.90,9.03 28.22,8.10 28.22,8.10
             28.22,8.10 26.59,8.10 26.59,8.10
             26.59,8.10 26.06,6.50 26.06,6.50
             26.06,6.50 25.53,8.10 25.53,8.10
             25.53,8.10 23.96,8.10 23.96,8.10
             23.96,8.10 25.24,9.00 25.24,9.00
             25.24,9.00 24.73,10.56 24.73,10.56
             24.73,10.56 26.08,9.59 26.08,9.59
             26.08,9.59 27.40,10.52 27.40,10.52
             27.40,10.52 26.90,9.03 26.90,9.03 Z
           M 28.68,15.48
           C 28.68,15.48 30.00,14.55 30.00,14.55
             30.00,14.55 28.37,14.55 28.37,14.55
             28.37,14.55 27.83,12.95 27.83,12.95
             27.83,12.95 27.31,14.55 27.31,14.55
             27.31,14.55 25.74,14.55 25.74,14.55
             25.74,14.55 27.01,15.44 27.01,15.44
             27.01,15.44 26.50,17.01 26.50,17.01
             26.50,17.01 27.86,16.04 27.86,16.04
             27.86,16.04 29.18,16.97 29.18,16.97
             29.18,16.97 28.68,15.48 28.68,15.48 Z
           M 15.77,28.47
           C 15.77,28.47 17.09,27.54 17.09,27.54
             17.09,27.54 15.46,27.54 15.46,27.54
             15.46,27.54 14.93,25.94 14.93,25.94
             14.93,25.94 14.40,27.54 14.40,27.54
             14.40,27.54 12.83,27.54 12.83,27.54
             12.83,27.54 14.11,28.44 14.11,28.44
             14.11,28.44 13.59,30.00 13.59,30.00
             13.59,30.00 14.95,29.03 14.95,29.03
             14.95,29.03 16.27,29.96 16.27,29.96
             16.27,29.96 15.77,28.47 15.77,28.47 Z
           M 9.39,26.74
           C 9.39,26.74 10.71,25.81 10.71,25.81
             10.71,25.81 9.08,25.81 9.08,25.81
             9.08,25.81 8.54,24.21 8.54,24.21
             8.54,24.21 8.02,25.81 8.02,25.81
             8.02,25.81 6.45,25.81 6.45,25.81
             6.45,25.81 7.72,26.71 7.72,26.71
             7.72,26.71 7.21,28.27 7.21,28.27
             7.21,28.27 8.57,27.30 8.57,27.30
             8.57,27.30 9.89,28.23 9.89,28.23
             9.89,28.23 9.39,26.74 9.39,26.74 Z
           M 4.69,21.92
           C 4.69,21.92 6.01,20.99 6.01,20.99
             6.01,20.99 4.38,20.99 4.38,20.99
             4.38,20.99 3.84,19.39 3.84,19.39
             3.84,19.39 3.32,20.99 3.32,20.99
             3.32,20.99 1.75,20.99 1.75,20.99
             1.75,20.99 3.02,21.89 3.02,21.89
             3.02,21.89 2.51,23.45 2.51,23.45
             2.51,23.45 3.87,22.49 3.87,22.49
             3.87,22.49 5.19,23.41 5.19,23.41
             5.19,23.41 4.69,21.92 4.69,21.92 Z
           M 15.77,2.53
           C 15.77,2.53 17.09,1.60 17.09,1.60
             17.09,1.60 15.46,1.60 15.46,1.60
             15.46,1.60 14.93,0.00 14.93,0.00
             14.93,0.00 14.40,1.60 14.40,1.60
             14.40,1.60 12.83,1.60 12.83,1.60
             12.83,1.60 14.11,2.50 14.11,2.50
             14.11,2.50 13.59,4.06 13.59,4.06
             13.59,4.06 14.95,3.09 14.95,3.09
             14.95,3.09 16.27,4.02 16.27,4.02
             16.27,4.02 15.77,2.53 15.77,2.53 Z
           M 9.39,4.31
           C 9.39,4.31 10.71,3.38 10.71,3.38
             10.71,3.38 9.08,3.38 9.08,3.38
             9.08,3.38 8.54,1.78 8.54,1.78
             8.54,1.78 8.02,3.38 8.02,3.38
             8.02,3.38 6.45,3.38 6.45,3.38
             6.45,3.38 7.72,4.28 7.72,4.28
             7.72,4.28 7.21,5.84 7.21,5.84
             7.21,5.84 8.57,4.87 8.57,4.87
             8.57,4.87 9.89,5.80 9.89,5.80
             9.89,5.80 9.39,4.31 9.39,4.31 Z
           M 4.69,9.03
           C 4.69,9.03 6.01,8.10 6.01,8.10
             6.01,8.10 4.38,8.10 4.38,8.10
             4.38,8.10 3.84,6.50 3.84,6.50
             3.84,6.50 3.32,8.10 3.32,8.10
             3.32,8.10 1.75,8.10 1.75,8.10
             1.75,8.10 3.02,9.00 3.02,9.00
             3.02,9.00 2.51,10.56 2.51,10.56
             2.51,10.56 3.87,9.59 3.87,9.59
             3.87,9.59 5.19,10.52 5.19,10.52
             5.19,10.52 4.69,9.03 4.69,9.03 Z
           M 2.94,15.48
           C 2.94,15.48 4.26,14.55 4.26,14.55
             4.26,14.55 2.63,14.55 2.63,14.55
             2.63,14.55 2.09,12.95 2.09,12.95
             2.09,12.95 1.57,14.55 1.57,14.55
             1.57,14.55 0.00,14.55 0.00,14.55
             0.00,14.55 1.28,15.44 1.28,15.44
             1.28,15.44 0.76,17.01 0.76,17.01
             0.76,17.01 2.12,16.04 2.12,16.04
             2.12,16.04 3.44,16.97 3.44,16.97
             3.44,16.97 2.94,15.48 2.94,15.48 Z
           M 15.04,2.30`
    ]
}

const faQuorumLogo = {
    prefix: 'q',
    iconName: 'quorum-logo',
    icon: [
        29,
        27,
        [],
        "F0004",
        `M27.72,18.789a12.856,12.856,0,0,0,-10.735,-1.897l-2.847,0.764a4.803,4.803,0,1,1,-1.234,-9.444c0.831,0,1.652,0.219,2.391,0.646a4.771,4.771,0,0,1,2.236,2.916a4.77,4.77,0,0,1,-0.224,3.131a14.8,14.8,0,0,1,1.629,-0.247a6.228,6.228,0,0,0,0.004,-3.262a6.222,6.222,0,0,0,-2.915,-3.803a6.211,6.211,0,0,0,-4.748,-0.625a6.216,6.216,0,0,0,-3.8,2.919a6.268,6.268,0,0,0,5.42,9.396c0.535,0,1.078,-0.07,1.618,-0.215l2.848,-0.764a11.404,11.404,0,0,1,9.52,1.683a0.729,0.729,0,0,0,1.016,-0.18a0.73,0.73,0,0,0,-0.18,-1.017 M26.885967,22.264173 L26.0524974,21.6799643 C26.051593,21.6792861 26.0503496,21.6788339 26.0494452,21.6781557 C25.9290539,21.5882861 25.8059496,21.5035035 25.682393,21.4197383 C25.6228191,21.3794948 25.5630191,21.3399296 25.502767,21.3010426 C25.4185496,21.2466687 25.3334278,21.1938774 25.2477409,21.1423296 C25.1715496,21.096547 25.0952452,21.0514426 25.0181496,21.0080339 C24.948967,20.9689209 24.8792191,20.9310513 24.8092452,20.893747 C24.7137235,20.8428774 24.6176365,20.7929122 24.5206452,20.7454339 C24.4694365,20.7203383 24.4177757,20.696147 24.3661148,20.6719557 C24.249793,20.6175817 24.1329061,20.5645643 24.0146626,20.5150513 C23.9825583,20.5014861 23.9501148,20.4885991 23.9178974,20.4754861 C23.7806626,20.4197557 23.6427496,20.366173 23.503593,20.3169991 C23.490367,20.3123643 23.4770278,20.3079557 23.4639148,20.3033209 C22.1664017,19.8494513 20.7855757,19.6801122 19.4037322,19.8161035 C19.3733235,19.8191557 19.3429148,19.8240165 19.3125061,19.8271817 C19.1709757,19.8423296 19.0297843,19.858947 18.8887061,19.8804252 C18.7916017,19.8952339 18.6948365,19.9146774 18.5979583,19.9325383 C18.5222191,19.9464426 18.4462539,19.9580861 18.3706278,19.9737991 C18.1945061,20.0106513 18.0186104,20.0524774 17.843167,20.0995035 L14.9954887,20.8632252 C10.674967,22.022373 6.21551478,19.445773 5.05749739,15.1195991 C3.89948,10.7936513 6.47336696,6.33114696 10.7953583,5.17177304 C15.1173496,4.01296435 19.5755583,6.58911217 20.7335757,10.91506 C21.059593,12.1337817 21.0955409,13.3917296 20.8545322,14.601747 C21.3438974,14.6192687 21.8313409,14.6618861 22.31528,14.7280165 C22.5656713,13.3492252 22.5133322,11.9217122 22.1427757,10.5372687 C20.7767583,5.43324261 15.5159409,2.39350348 10.41768,3.76110348 C5.31862783,5.12870348 2.28194087,10.3938165 3.64829739,15.4978426 C5.01442783,20.6017557 10.274567,23.6410426 15.373393,22.2738948 L18.2210713,21.51006 C20.6444974,20.8605122 23.1869583,21.3530426 25.19608,22.8622861 C25.1996974,22.8648861 25.2035409,22.8665817 25.2070452,22.8690687 C25.2100974,22.8713296 25.2123583,22.8741557 25.2155235,22.8764165 L26.048993,23.4606252 C26.17628,23.5498165 26.3223322,23.59266 26.4668017,23.59266 C26.6967322,23.59266 26.9231583,23.4841383 27.0650278,23.2813383 C27.2962017,22.9509122 27.2158278,22.495573 26.885967,22.264173 M18.7015739,23.2672983 L15.8538957,24.031133 C12.9051565,24.8218722 9.82426957,24.4161591 7.17995652,22.8880374 C4.53575652,21.3598026 2.64431304,18.8922896 1.85402609,15.9402722 C1.06385217,12.9879157 1.46933913,9.90454174 2.9959913,7.2576287 C4.52264348,4.61071565 6.98766957,2.71746348 9.93708696,1.92638522 C16.0252696,0.293924348 22.3058522,3.92307217 23.9369565,10.017133 C24.3849478,11.6908548 24.4494957,13.3986026 24.1404348,15.0571765 C24.6134087,15.1843504 25.0808435,15.3349243 25.5407043,15.5094635 C25.9300261,13.5806026 25.8683043,11.5891157 25.3462696,9.63911565 C23.5068261,2.76720261 16.4253304,-1.32666696 9.5594087,0.515715652 C6.23378261,1.40774174 3.45393043,3.54256783 1.73250435,6.52736783 C0.0109652174,9.51194174 -0.446295652,12.9892722 0.444713043,16.3180635 C1.33583478,19.6471939 3.46873913,22.4296461 6.45048696,24.1527678 C8.43677391,25.3008374 10.6408957,25.8869678 12.8745217,25.8869678 C13.9939913,25.8869678 15.1212609,25.7395591 16.231687,25.4418026 L19.0793652,24.6779678 C20.6242174,24.2637765 22.2685478,24.6451852 23.4766435,25.6986374 C23.7805043,25.9633852 24.2411565,25.9319591 24.5060174,25.6277591 C24.7706522,25.3235591 24.738887,24.8623417 24.4351391,24.5974809 C22.8597652,23.2240026 20.7162348,22.7264983 18.7015739,23.2672983`
    ]
}

const faBoolean = {
    prefix: 'q',
    iconName: 'boolean',
    icon: [
        25,
        17,
        [],
        "f0004",
        "M15.725,0 C14.4455223,0.00149566126 13.1841363,0.302287713 12.0416667,0.878333333 C10.899197,0.302287713 9.63781102,0.00149566126 8.35833333,0 C3.7193297,0.0773274231 -0.000644439575,3.86035197 0,8.5 C-0.000644439575,13.139648 3.7193297,16.9226726 8.35833333,17 C9.63781102,16.9985043 10.899197,16.6977123 12.0416667,16.1216667 C13.1841363,16.6977123 14.4455223,16.9985043 15.725,17 C20.3640036,16.9226726 24.0839778,13.139648 24.0833333,8.5 C24.0839778,3.86035197 20.3640036,0.0773274231 15.725,0 Z M8.35833333,15.045 C6.63749965,15.0300365 4.99309858,14.3320536 3.78691301,13.1046136 C2.58072743,11.8771737 1.91157193,10.2208325 1.92666667,8.5 C1.91157193,6.77916746 2.58072743,5.12282632 3.78691301,3.89538637 C4.99309858,2.66794643 6.63749965,1.96996348 8.35833333,1.955 C8.95271175,1.96035705 9.54363071,2.04613561 10.115,2.21 C8.36243662,3.83215162 7.36611514,6.11193504 7.36611514,8.5 C7.36611514,10.888065 8.36243662,13.1678484 10.115,14.79 C9.54363071,14.9538644 8.95271175,15.039643 8.35833333,15.045 L8.35833333,15.045 Z M15.725,15.045 C15.1306216,15.039643 14.5397026,14.9538644 13.9683333,14.79 C15.7208967,13.1678484 16.7172182,10.888065 16.7172182,8.5 C16.7172182,6.11193504 15.7208967,3.83215162 13.9683333,2.21 C14.5397026,2.04613561 15.1306216,1.96035705 15.725,1.955 C17.4458337,1.96996348 19.0902348,2.66794643 20.2964203,3.89538637 C21.5026059,5.12282632 22.1717614,6.77916746 22.1566667,8.5 C22.1717614,10.2208325 21.5026059,11.8771737 20.2964203,13.1046136 C19.0902348,14.3320536 17.4458337,15.0300365 15.725,15.045 L15.725,15.045 Z"
    ]
}

const faCards = {
  prefix: 'q',
  iconName: 'cards',
  icon: [
    20,
    20,
    [],
    "f0005",
    `
      M18.5 0h-17A1.5 1.5 0 0 0 0 1.5v6A1.5 1.5 0 0 0 1.5 9h17A1.5 1.5 0 0 0 20 7.5v-6A1.5 1.5 0 0 0 18.5 0zm-17 1h17a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5zM18.5 11a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 0 18.5v-6A1.5 1.5 0 0 1 1.5 11zm0 1h-17a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5z
      M11.5 3a.5.5 0 0 1 .09.992L11.5 4h-8a.5.5 0 0 1-.09-.992L3.5 3h8zM5.5 5a.5.5 0 0 1 .09.992L5.5 6h-2a.5.5 0 0 1-.09-.992L3.5 5h2zM11.5 14a.5.5 0 0 1 .09.992L11.5 15h-8a.5.5 0 0 1-.09-.992L3.5 14h8zM5.5 16a.5.5 0 0 1 .09.992L5.5 17h-2a.5.5 0 0 1-.09-.992L3.5 16h2z
      M 14, 4.5
      a 1.5,1.5 0 1,0 3,0
      a 1.5,1.5 0 1,0 -3,0
      M 14, 15.5
      a 1.5,1.5 0 1,0 3,0
      a 1.5,1.5 0 1,0 -3,0
    `,
  ]
}

const faAvatar = {
    prefix: "q",
    iconName: "avatar",
    icon: [
        56,
        66,
        [],
        "F0006",
        "M4.13559 65V66C4.68788 66 5.13559 65.5523 5.13559 65H4.13559ZM1.9661 65H0.966103C0.966103 65.5523 1.41382 66 1.9661 66L1.9661 65ZM51.8644 65H50.8644C50.8644 65.5523 51.3121 66 51.8644 66V65ZM54.0339 65V66C54.5862 66 55.0339 65.5523 55.0339 65H54.0339ZM41.1017 17.2712C41.1017 24.5071 35.2359 30.3729 28 30.3729V32.3729C36.3404 32.3729 43.1017 25.6116 43.1017 17.2712H41.1017ZM28 4.16949C35.2359 4.16949 41.1017 10.0353 41.1017 17.2712H43.1017C43.1017 8.93075 36.3404 2.16949 28 2.16949V4.16949ZM14.8983 17.2712C14.8983 10.0353 20.7641 4.16949 28 4.16949V2.16949C19.6596 2.16949 12.8983 8.93075 12.8983 17.2712H14.8983ZM28 30.3729C20.7641 30.3729 14.8983 24.5071 14.8983 17.2712H12.8983C12.8983 25.6116 19.6596 32.3729 28 32.3729V30.3729ZM43.2712 17.2712C43.2712 25.7052 36.434 32.5424 28 32.5424V34.5424C37.5386 34.5424 45.2712 26.8098 45.2712 17.2712H43.2712ZM28 2C36.434 2 43.2712 8.83714 43.2712 17.2712H45.2712C45.2712 7.73257 37.5386 0 28 0V2ZM12.7288 17.2712C12.7288 8.83714 19.566 2 28 2V0C18.4614 0 10.7288 7.73257 10.7288 17.2712H12.7288ZM28 32.5424C19.566 32.5424 12.7288 25.7052 12.7288 17.2712H10.7288C10.7288 26.8098 18.4614 34.5424 28 34.5424V32.5424ZM4.13559 64H1.9661V66H4.13559V64ZM3.13559 62.8305V65H5.13559V62.8305H3.13559ZM25.8305 40.1356C13.2965 40.1356 3.13559 50.2965 3.13559 62.8305H5.13559C5.13559 51.401 14.401 42.1356 25.8305 42.1356V40.1356ZM30.1695 40.1356H25.8305V42.1356H30.1695V40.1356ZM52.8644 62.8305C52.8644 50.2965 42.7035 40.1356 30.1695 40.1356V42.1356C41.599 42.1356 50.8644 51.401 50.8644 62.8305H52.8644ZM52.8644 65V62.8305H50.8644V65H52.8644ZM54.0339 64H51.8644V66H54.0339V64ZM53.0339 62.8305V65H55.0339V62.8305H53.0339ZM30.1695 39.9661C42.7972 39.9661 53.0339 50.2028 53.0339 62.8305H55.0339C55.0339 49.0983 43.9017 37.9661 30.1695 37.9661V39.9661ZM25.8305 39.9661H30.1695V37.9661H25.8305V39.9661ZM2.9661 62.8305C2.9661 50.2028 13.2028 39.9661 25.8305 39.9661V37.9661C12.0983 37.9661 0.966103 49.0983 0.966103 62.8305H2.9661ZM2.9661 65V62.8305H0.966103V65H2.9661Z"
    ]
}

const faXTwitterBrand = {
  prefix: 'q',
  iconName: 'x-twitter',
  icon: [
    512,
    512,
    [],
    "f0007",
    "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
  ]
}

const faNeutral = {
  prefix: "q",
  iconName: "neutral",
  icon: [
    16,
    16,
    [],
    "f0011",
    `
    M4.25806 8.90323C4.04516 8.90323 3.87097 8.72903 3.87097 8.51613V7.48387C3.87097 7.27097 4.04516 7.09677 4.25806 7.09677H11.7419C11.9548 7.09677 12.129 7.27097 12.129 7.48387V8.51613C12.129 8.72903 11.9548 8.90323 11.7419 8.90323H4.25806ZM16 8C16 12.4194 12.4194 16 8 16C3.58065 16 0 12.4194 0 8C0 3.58065 3.58065 0 8 0C12.4194 0 16 3.58065 16 8ZM14.4516 8C14.4516 4.43548 11.5645 1.54839 8 1.54839C4.43548 1.54839 1.54839 4.43548 1.54839 8C1.54839 11.5645 4.43548 14.4516 8 14.4516C11.5645 14.4516 14.4516 11.5645 14.4516 8Z
    `
  ]
}

// This is from Font Awesome 6. We are importing as a custom icon.
const faBoltSlash = {
  prefix: 'q',
  iconName: 'bolt-slash',
  icon: [
      24,
      20,
      [],
      "f0008",
      "M1.45521 0.191217C1.06521 -0.116283 0.498961 -0.0450334 0.191461 0.344967C-0.116039 0.734967 -0.0447892 1.30122 0.345211 1.60872L22.5452 19.0087C22.9352 19.3162 23.5015 19.245 23.809 18.855C24.1165 18.465 24.0452 17.8987 23.6552 17.5912L16.8827 12.285L18.739 10.71C19.0315 10.4625 19.2002 10.095 19.2002 9.71247C19.2002 8.98872 18.6152 8.40372 17.8915 8.40372H14.6927L16.7027 1.37247C16.8977 0.686217 16.3802 -3.33539e-05 15.664 -3.33539e-05C15.409 -3.33539e-05 15.1577 0.0899667 14.9627 0.258717L8.54646 5.74872L1.45521 0.191217ZM9.99021 6.88122L14.3102 3.18747L12.6565 8.97372L9.99021 6.88497V6.88122ZM14.224 10.2H16.5565L15.439 11.1487L14.224 10.2ZM12.6152 13.5412L9.68271 16.0312L10.804 12.1125L9.27771 10.9087L7.29771 17.8275C7.10271 18.5175 7.61646 19.2 8.33271 19.2C8.58771 19.2 8.83521 19.11 9.03021 18.945L14.059 14.6775L12.6152 13.5412ZM5.75271 8.13372L5.23896 8.57247C4.95771 8.81247 4.79646 9.16497 4.79646 9.53247C4.79646 10.23 5.36271 10.7962 6.06021 10.7962H9.13521L5.75271 8.12997V8.13372Z"
  ]
}

// From Font Awesome 6.
const faSparkle = {
  prefix: "q",
  iconName: "sparkle",
  icon: [
      9,
      8,
      [],
      "f0009",
      "M8.00141 3.9927C8.00135 3.93077 7.9841 3.87007 7.95158 3.81736C7.91907 3.76465 7.87256 3.72199 7.81724 3.69415L5.47194 2.51931L4.29939 0.16985C4.18606 -0.0566167 3.81625 -0.0566167 3.70312 0.16985L2.53058 2.51931L0.18528 3.69415C0.129644 3.72173 0.0828187 3.76431 0.0500823 3.81708C0.0173458 3.86985 0 3.93071 0 3.99281C0 4.05491 0.0173458 4.11577 0.0500823 4.16854C0.0828187 4.22131 0.129644 4.26388 0.18528 4.29147L2.53058 5.4663L3.70312 7.81577C3.73081 7.87113 3.77337 7.91769 3.82602 7.95023C3.87868 7.98277 3.93936 8 4.00126 8C4.06316 8 4.12384 7.98277 4.17649 7.95023C4.22915 7.91769 4.27171 7.87113 4.29939 7.81577L5.47194 5.4663L7.81724 4.29188C7.87264 4.26397 7.9192 4.22122 7.95172 4.16839C7.98424 4.11556 8.00144 4.05474 8.00141 3.9927Z"
  ]
}

const faPaperPlaneTop = {
  prefix: "q",
  iconName: "paper-plane-top",
  icon: [
      14,
      13,
      [],
      "f0009",
      "M2.14844 0.947754L12.5078 5.44775C13.2578 5.77588 13.2578 6.83057 12.5078 7.15869L2.14844 11.6587C1.35156 12.0103 0.53125 11.1196 0.953125 10.3462L2.59375 7.32275C2.6875 7.13525 2.875 6.99463 3.10938 6.97119L7.23438 6.45557C7.30469 6.45557 7.375 6.38525 7.375 6.2915C7.375 6.22119 7.30469 6.15088 7.23438 6.15088L3.10938 5.63525C2.875 5.58838 2.6875 5.47119 2.59375 5.28369L0.953125 2.26025C0.53125 1.48682 1.35156 0.596191 2.14844 0.947754Z"
    ]
}

const faFilterSlash = {
  prefix: "q",
  iconName: "filter-slash",
  icon: [
    33,
    33,
    [],
    "f0010",
    `
    M31.6069 31.0014C31.1258 31.4542 30.3753 31.4542 29.8942 31.0014L0.393129 3.2357C-0.13104 2.74236 -0.131044 1.90931 0.393122 1.41597C0.874232 0.963153 1.62471 0.963151 2.10582 1.41596L31.6069 29.1817C32.131 29.675 32.131 30.5081 31.6069 31.0014Z
    M19.6804 16.6179V14.0028L28.3118 5.36875C29.9192 3.76133 28.78 1 26.5022 1H4.32847C3.95464 1 3.61128 1.07458 3.30562 1.20638L5.80544 3.55916H26.5048L17.1212 12.9427V14.2093L19.6804 16.6179Z
    M13.709 17.1071V23.1794L17.1212 25.7386V20.3186L19.6804 22.7272V25.7741C19.6804 27.9034 17.2531 28.9866 15.5857 27.8214L12.1735 25.312C11.5291 24.7434 11.1498 23.9849 11.1498 23.1794V14.6985L13.709 17.1071Z
    `
  ]
}

const faBarsStaggered = {
  prefix: "q",
  iconName: "bars-staggered",
  icon: [
    24,
    24,
    [],
    "f0010",
    `
    M5.625 6.78068C5.625 6.20427 6.1008 5.73682 6.6875 5.73682H19.4375C20.0252 5.73682 20.5 6.20427 20.5 6.78068C20.5 7.35806 20.0252 7.82454 19.4375 7.82454H6.6875C6.1008 7.82454 5.625
    7.35806 5.625 6.78068ZM4.91667 12C4.91667 11.4226 5.39247 10.9561 5.97917 10.9561H18.7292C19.3169 10.9561 19.7917 11.4226 19.7917 12C19.7917 12.5774 19.3169 13.0438 18.7292 13.0438H5.97917C5.39247
    13.0438 4.91667 12.5774 4.91667 12ZM17.3125 18.2631H4.5625C3.9758 18.2631 3.5 17.7967 3.5 17.2193C3.5 16.6419 3.9758 16.1754 4.5625 16.1754H17.3125C17.9002 16.1754 18.375 16.6419 18.375 17.2193C18.375 17.7967 17.9002 18.2631 17.3125 18.2631Z
    `
  ]
}

const faBasket = {
  prefix: "q",
  iconName: "basket",
  icon: [
    24,
    24,
    [],
    "f0010",
    `M10.5938 4.09375C10.9375 4.28125 11.0938 4.75 10.9062 5.125L8.34375 10H15.625L13.0625 5.125C12.875 4.75 13.0312 4.28125 13.375 4.09375C13.75 3.90625 14.2188 4.0625 14.4062 4.40625L17.3125 10H18.4375H20H20.25C20.6562 10 21 10.3438 21 10.75C21 11.1875 20.6562 11.5 20.25 11.5H19.625L17.875 18.5C17.6562 19.375 16.8438 20 15.9375 20H8.0625C7.125 20 6.34375 19.375 6.09375 18.5L4.375 11.5H3.75C3.3125 11.5 3 11.1875 3 10.75C3 10.3438 3.3125 10 3.75 10H4H5.53125H6.65625L9.5625 4.40625C9.75 4.0625 10.2188 3.90625 10.5938 4.09375ZM5.90625 11.5L7.5625 18.125C7.625 18.3438 7.8125 18.5 8.0625 18.5H15.9375C16.1562 18.5 16.3438 18.3438 16.4062 18.125L18.0625 11.5H5.90625ZM10 13.75V16.25C10 16.6875 9.65625 17 9.25 17C8.8125 17 8.5 16.6875 8.5 16.25V13.75C8.5 13.3438 8.8125 13 9.25 13C9.65625 13 10 13.3438 10 13.75ZM12 13C12.4062 13 12.75 13.3438 12.75 13.75V16.25C12.75 16.6875 12.4062 17 12 17C11.5625 17 11.25 16.6875 11.25 16.25V13.75C11.25 13.3438 11.5625 13 12 13ZM15.5 13.75V16.25C15.5 16.6875 15.1562 17 14.75 17C14.3125 17 14 16.6875 14 16.25V13.75C14 13.3438 14.3125 13 14.75 13C15.1562 13 15.5 13.3438 15.5 13.75Z`
  ]
};

const faQuorumLink = {
  prefix: "q",
  iconName: "link",
  icon: [
    24,
    24,
    [],
    "f0011",
    `M8.8125 1.40625C8.8125 1.05078 9.08594 0.75 9.46875 0.75H13.8164C14.1992 0.75 14.4727 1.05078 14.4727 1.40625V5.78125C14.4727 6.16406 14.1992 6.4375 13.8164 6.4375C13.4609 6.4375 13.1602 6.16406 13.1602 5.78125V2.99219L7.0625 9.08984C6.81641 9.36328 6.40625 9.36328 6.16016 9.08984C5.88672 8.84375 5.88672 8.43359 6.16016 8.16016L12.2578 2.0625H9.46875C9.08594 2.0625 8.8125 1.78906 8.8125 1.40625ZM2.46875 1.625H5.96875C6.32422 1.625 6.625 1.92578 6.625 2.28125C6.625 2.66406 6.32422 2.9375 5.96875 2.9375H2.46875C2.08594 2.9375 1.8125 3.23828 1.8125 3.59375V12.7812C1.8125 13.1641 2.08594 13.4375 2.46875 13.4375H11.6562C12.0117 13.4375 12.3125 13.1641 12.3125 12.7812V9.28125C12.3125 8.92578 12.5859 8.625 12.9688 8.625C13.3242 8.625 13.625 8.92578 13.625 9.28125V12.7812C13.625 13.875 12.7227 14.75 11.6562 14.75H2.46875C1.375 14.75 0.5 13.875 0.5 12.7812V3.59375C0.5 2.52734 1.375 1.625 2.46875 1.625Z`
  ]
};

const faQuorumCard = {
  prefix: "q",
  iconName: "quorum-card",
  icon: [
    24,
    24,
    [],
    "f0010",
    `M0.75 2.375C0.75 1.76562 1.24219 1.25 1.875 1.25H4.125C4.73438 1.25 5.25 1.76562 5.25 2.375V6.125C5.25 6.75781 4.73438 7.25 4.125 7.25H1.875C1.24219 7.25 0.75 6.75781 0.75 6.125V2.375ZM1.5 2.375V6.125C1.5 6.33594 1.66406 6.5 1.875 6.5H4.125C4.3125 6.5 4.5 6.33594 4.5 6.125V2.375C4.5 2.1875 4.3125 2 4.125 2H1.875C1.66406 2 1.5 2.1875 1.5 2.375ZM6.75 6.875C6.75 6.26562 7.24219 5.75 7.875 5.75H10.125C10.7344 5.75 11.25 6.26562 11.25 6.875V10.625C11.25 11.2578 10.7344 11.75 10.125 11.75H7.875C7.24219 11.75 6.75 11.2578 6.75 10.625V6.875ZM7.5 6.875V10.625C7.5 10.8359 7.66406 11 7.875 11H10.125C10.3125 11 10.5 10.8359 10.5 10.625V6.875C10.5 6.6875 10.3125 6.5 10.125 6.5H7.875C7.66406 6.5 7.5 6.6875 7.5 6.875ZM4.125 8C4.73438 8 5.25 8.51562 5.25 9.125V10.625C5.25 11.2578 4.73438 11.75 4.125 11.75H1.875C1.24219 11.75 0.75 11.2578 0.75 10.625V9.125C0.75 8.51562 1.24219 8 1.875 8H4.125ZM4.125 8.75H1.875C1.66406 8.75 1.5 8.9375 1.5 9.125V10.625C1.5 10.8359 1.66406 11 1.875 11H4.125C4.3125 11 4.5 10.8359 4.5 10.625V9.125C4.5 8.9375 4.3125 8.75 4.125 8.75ZM6.75 2.375C6.75 1.76562 7.24219 1.25 7.875 1.25H10.125C10.7344 1.25 11.25 1.76562 11.25 2.375V3.875C11.25 4.50781 10.7344 5 10.125 5H7.875C7.24219 5 6.75 4.50781 6.75 3.875V2.375ZM7.5 2.375V3.875C7.5 4.08594 7.66406 4.25 7.875 4.25H10.125C10.3125 4.25 10.5 4.08594 10.5 3.875V2.375C10.5 2.1875 10.3125 2 10.125 2H7.875C7.66406 2 7.5 2.1875 7.5 2.375Z`
  ]
};

const faQuorumList = {
  prefix: "q",
  iconName: "quorum-list",
  icon: [
    24,
    24,
    [],
    "f0010",
    `M0.375 2.1875C0.375 1.88281 0.609375 1.625 0.9375 1.625H2.0625C2.36719 1.625 2.625 1.88281 2.625 2.1875V3.3125C2.625 3.64062 2.36719 3.875 2.0625 3.875H0.9375C0.609375 3.875 0.375 3.64062 0.375 3.3125V2.1875ZM1.875 3.125V2.375H1.125V3.125H1.875ZM11.625 2.375C11.8125 2.375 12 2.5625 12 2.75C12 2.96094 11.8125 3.125 11.625 3.125H4.125C3.91406 3.125 3.75 2.96094 3.75 2.75C3.75 2.5625 3.91406 2.375 4.125 2.375H11.625ZM11.625 6.125C11.8125 6.125 12 6.3125 12 6.5C12 6.71094 11.8125 6.875 11.625 6.875H4.125C3.91406 6.875 3.75 6.71094 3.75 6.5C3.75 6.3125 3.91406 6.125 4.125 6.125H11.625ZM11.625 9.875C11.8125 9.875 12 10.0625 12 10.25C12 10.4609 11.8125 10.625 11.625 10.625H4.125C3.91406 10.625 3.75 10.4609 3.75 10.25C3.75 10.0625 3.91406 9.875 4.125 9.875H11.625ZM2.0625 5.375C2.36719 5.375 2.625 5.63281 2.625 5.9375V7.0625C2.625 7.39062 2.36719 7.625 2.0625 7.625H0.9375C0.609375 7.625 0.375 7.39062 0.375 7.0625V5.9375C0.375 5.63281 0.609375 5.375 0.9375 5.375H2.0625ZM1.125 6.125V6.875H1.875V6.125H1.125ZM0.375 9.6875C0.375 9.38281 0.609375 9.125 0.9375 9.125H2.0625C2.36719 9.125 2.625 9.38281 2.625 9.6875V10.8125C2.625 11.1406 2.36719 11.375 2.0625 11.375H0.9375C0.609375 11.375 0.375 11.1406 0.375 10.8125V9.6875ZM1.875 10.625V9.875H1.125V10.625H1.875Z`
  ]
};

const faQuorumOneColumn = {
  prefix: "q",
  iconName: "quorum-one-column",
  icon: [
    24,
    24,
    [],
    "f0010",
    `M9.75 1.25C10.5703 1.25 11.25 1.92969 11.25 2.75V10.25C11.25 11.0938 10.5703 11.75 9.75 11.75H2.25C1.40625 11.75 0.75 11.0938 0.75 10.25V2.75C0.75 1.92969 1.40625 1.25 2.25 1.25H9.75ZM9.75 2H2.25C1.82812 2 1.5 2.35156 1.5 2.75V10.25C1.5 10.6719 1.82812 11 2.25 11H9.75C10.1484 11 10.5 10.6719 10.5 10.25V2.75C10.5 2.35156 10.1484 2 9.75 2Z`
  ]
};

const faQuorumTwoColumns = {
  prefix: "q",
  iconName: "quorum-two-columns",
  icon: [
    24,
    24,
    [],
    "f0010",
    `M10.501 1.25C11.3213 1.25 12.001 1.92969 12.001 2.75V10.25C12.001 11.0938 11.3213 11.75 10.501 11.75H1.50098C0.657227 11.75 0.000976562 11.0938 0.000976562 10.25V2.75C0.000976562 1.92969 0.657227 1.25 1.50098 1.25H10.501ZM10.501 2H1.50098C1.0791 2 0.750977 2.35156 0.750977 2.75V4.25H11.251V2.75C11.251 2.35156 10.8994 2 10.501 2ZM1.50098 11H5.62598V5H0.750977V10.25C0.750977 10.6719 1.0791 11 1.50098 11ZM6.37598 11H10.501C10.8994 11 11.251 10.6719 11.251 10.25V5H6.37598V11Z`
  ]
};

const faQuorumThreeColumns = {
  prefix: "q",
  iconName: "quorum-three-columns",
  icon: [
    24,
    24,
    [],
    "f0010",
    `M0.500977 2.75C0.500977 1.92969 1.15723 1.25 2.00098 1.25H14.001C14.8213 1.25 15.501 1.92969 15.501 2.75V10.25C15.501 11.0938 14.8213 11.75 14.001 11.75H2.00098C1.15723 11.75 0.500977 11.0938 0.500977 10.25V2.75ZM11.001 11H14.001C14.3994 11 14.751 10.6719 14.751 10.25V2.75C14.751 2.35156 14.3994 2 14.001 2H11.001V11ZM10.251 2H5.75098V11H10.251V2ZM5.00098 11V2H2.00098C1.5791 2 1.25098 2.35156 1.25098 2.75V10.25C1.25098 10.6719 1.5791 11 2.00098 11H5.00098Z`
  ]
};

/**
 * Imperatively and explicitly include the set of FA SVGs to reduce bundle size:
 * via https://github.com/FortAwesome/react-fontawesome#build-a-library-to-reference-icons-throughout-your-app-more-conveniently
 */
export const initializeFontAwesome = () => {
    library.add(
        faAddressCardProRegular,
        faBracketsCurlyProRegular,
        faArrowsAltProRegular,
        faAddressBookProRegular,
        faAnalyticsProRegular,
        faAngleDownProRegular,
        faAngleLeftProRegular,
        faAngleRightProRegular,
        faAngleUpProRegular,
        faArchiveProRegular,
        faArrowAltCircleRightProRegular,
        faArrowCircleDownProRegular,
        faArrowCircleRightProRegular,
        faArrowCircleUpProRegular,
        faArrowDownProRegular,
        faArrowFromLeftProRegular,
        faArrowFromRightProRegular,
        faArrowLeftProRegular,
        faArrowRightProRegular,
        faArrowToBottomProRegular,
        faArrowUpProRegular,
        faArrowsVProRegular,
        faAtProRegular,
        faAwardProRegular,
        faBanProRegular,
        faBell,
        faBellProRegular,
        faBellProSolid,
        faBellProLight,
        faBellProDuotone,
        faBoltProRegular,
        faBookProRegular,
        faBoxBallotProRegular,
        faBuildingProRegular,
        faBullhornProRegular,
        faBullseyeArrowProRegular,
        faCalendarAltProRegular,
        faCalendarCheckProRegular,
        faCalendarDayProRegular,
        faCalendarMinusProRegular,
        faCalendarPlusProRegular,
        faCalendarProRegular,
        faCameraProRegular,
        faChartBarProRegular,
        faChartLineChartLineProRegular,
        faChartLineProRegular,
        faCheckProRegular,
        faCheckCircleProRegular,
        faCheckSquareProRegular,
        faChevronDownProRegular,
        faChevronRightProRegular,
        faChevronUpProRegular,
        faChildProRegular,
        faCircleProRegular,
        faPlusCircleProRegular,
        faClipboardProRegular,
        faClipboardUserProRegular,
        faClockProRegular,
        faCloudDownloadAltProRegular,
        faCodeProRegular,
        faCogProRegular,
        faColumnsProRegular,
        faCommentAltProRegular,
        faCommentsAltProRegular,
        faCommentsProRegular,
        faCommentProRegular,
        faCommentDotsProRegular,
        faCopyProRegular,
        faCreditCardProRegular,
        faDollarSignProRegular,
        faDotCircleProRegular,
        faDownloadProRegular,
        faEditProRegular,
        faEllipsisVProRegular,
        faEmptySetRegular,
        faEnvelopeProRegular,
        faEnvelopeOpenProRegular,
        faExchangeAltProRegular,
        faExclamationTriangleProRegular,
        faExclamationCircleProRegular,
        faExternalLinkAltProRegular,
        faExternalLinkProRegular,
        faEyeProRegular,
        faEraserProRegular,
        faFastBackwardRegular,
        faFileAltProRegular,
        faFileAudioProRegular,
        faFileExcelProRegular,
        faFilePdfProRegular,
        faFileProRegular,
        faFileVideoProRegular,
        faFileWordProRegular,
        faFileTimesProRegular,
        faFlagProRegular,
        faFlagAltProRegular,
        faFolderProRegular,
        faFolderOpenRegular,
        faFoldersProRegular,
        faGavelProRegular,
        faGiftProRegular,
        faGlobeProRegular,
        faGlobeAmericasProRegular,
        faGraduationCapProRegular,
        faHandPaperProRegular,
        faHandPeaceProRegular,
        faHandPointerProRegular,
        faHandshakeProRegular,
        faHeartProRegular,
        faHistoryProRegular,
        faHomeProRegular,
        faHospitalProRegular,
        faImageProRegular,
        faInfoCircleProRegular,
        faLandmarkProRegular,
        faLayerGroupProRegular,
        faLayerPlusRegular,
        faLightbulbProRegular,
        faLinkProRegular,
        faLifeRingProRegular,
        faListUlProRegular,
        faLocationProRegular,
        faLockProRegular,
        faLongArrowLeftProRegular,
        faLongArrowRightProRegular,
        faMagicProRegular,
        faMapProRegular,
        faMapMarkerAltProRegular,
        faMegaphoneProRegular,
        faMinusProRegular,
        faMinusCircleProRegular,
        faMoneyBillProRegular,
        faMoneyBillAltProRegular,
        faMoneyCheckEditAltProRegular,
        faNewspaperProRegular,
        faPaintBrushAltProRegular,
        faPaperclipRegular,
        faPaletteProRegular,
        faPaperPlaneProRegular,
        faPaperPlaneTop,
        faPenProRegular,
        faPenAltProRegular,
        faPencilProRegular,
        faPencilAltProRegular,
        faPhoneProRegular,
        faPlusProRegular,
        faPodiumProRegular,
        faProjectDiagramProRegular,
        faQuestionCircleProRegular,
        faReceiptProRegular,
        faRibbonProRegular,
        faRssProRegular,
        faSearchProRegular,
        faSeedlingProRegular,
        faShareAltProRegular,
        faShareProRegular,
        faShareSquareProRegular,
        faShieldCheckProRegular,
        faSignInAltProRegular,
        faSignOutAltProRegular,
        faSortAmountDownProRegular,
        faSparklesProRegular,
        faSquareProRegular,
        faStarProRegular,
        faStickyNoteProRegular,
        faSyncProRegular,
        faTableProRegular,
        faTachometerAltFastProRegular,
        faThumbsUpProRegular,
        faThumbsDownProRegular,
        faThumbtackProRegular,
        faTimesCircleProRegular,
        faTimesProRegular,
        faTrashProRegular,
        faTrashAltProRegular,
        faUniversityProRegular,
        faUploadProRegular,
        faUsdSquareProRegular,
        faUserPlusProRegular,
        faUserProRegular,
        faUsersCogProRegular,
        faUsersProRegular,
        faVideoProRegular,
        faStarShootingProRegular,
        faLaughProRegular,
        faCommentEditProRegular,
        faSearchPlusProRegular,
        faCompressAltProRegular,
        faExpandAltProRegular,
        faTasksProRegular,
        faCloneProRegular,

        faAddressBookProSolid,
        faAdjustProSolid,
        faCaretDownProSolid,
        faAlignCenterProSolid,
        faAlignJustifyProSolid,
        faAngleDownProSolid,
        faAngleLeftProSolid,
        faAngleRightProSolid,
        faAngleUpProSolid,
        faAngryProSolid,
        faAppleAltProSolid,
        faArchiveProSolid,
        faArrowAltCircleDownProSolid,
        faArrowAltCircleRightProSolid,
        faArrowAltCircleUpProSolid,
        faArrowsAltHProSolid,
        faArrowFromBottomSolid,
        faAsteriskProSolid,
        faAwardProSolid,
        faBallPileProSolid,
        faBathProSolid,
        faBatProSolid,
        faBinocularsProSolid,
        faBlogProSolid,
        faBookProSolid,
        faBookReaderProSolid,
        faBriefcaseProSolid,
        faBroadcastTowerProSolid,
        faBuildingProSolid,
        faBullhornProSolid,
        faCalendarAltProSolid,
        faCalendarPlusProSolid,
        faCarrotProSolid,
        faCartPlusProSolid,
        faCatProSolid,
        faChalkboardTeacherProSolid,
        faChartBarProSolid,
        faChartLineProSolid,
        faChartPieProSolid,
        faCheckCircleProSolid,
        faCircleProSolid,
        faPlusCircleProSolid,
        faCheckProSolid,
        faCloudDownloadAltProSolid,
        faCloudDownloadProSolid,
        faCodeProSolid,
        faCoffeeProSolid,
        faCogProSolid,
        faCommentDotsProSolid,
        faColumnsProSolid,
        faCommentsProSolid,
        faCommentProSolid,
        faCopyProSolid,
        faCowProSolid,
        faDesktopProSolid,
        faDivideProSolid,
        faDogProSolid,
        faDollarSignProSolid,
        faDownloadProSolid,
        faEmptySetProSolid,
        faEnvelopeProSolid,
        faEnvelopeOpenProSolid,
        faEnvelopeSquareProSolid,
        faExchangeAltProSolid,
        faExclamationProSolid,
        faExclamationSquareProSolid,
        faExclamationTriangleProSolid,
        faExternalLinkSolid,
        faEyeProSolid,
        faFastBackwardSolid,
        faFaxProSolid,
        faFileAltProSolid,
        faFileAudioProSolid,
        faFileInvoiceDollarProSolid,
        faFileInvoiceProSolid,
        faFileProSolid,
        faFileSearchProSolid,
        faFilterProSolid,
        faFlagProSolid,
        faFlagAltProSolid,
        faFlaskProSolid,
        faFolderOpenProSolid,
        faFoldersProSolid,
        faFrogProSolid,
        faGavelProSolid,
        faGiftProSolid,
        faGlassMartiniProSolid,
        faGlobeProSolid,
        faGlobeAmericasProSolid,
        faGraduationCapProSolid,
        faGripLinesProSolid,
        faGripVerticalProSolid,
        faHashtagProSolid,
        faHeartProSolid,
        faHippoProSolid,
        faHomeProSolid,
        faHorizontalRuleProSolid,
        faHourglassEndProSolid,
        faHourglassStartProSolid,
        faInboxProSolid,
        faIndustryProSolid,
        faIslandTropicalProSolid,
        faLanguageProSolid,
        faLaptopProSolid,
        faLeafProSolid,
        faListAltProSolid,
        faListProSolid,
        faListOlProSolid,
        faListUlProSolid,
        faLocationProSolid,
        faLocationArrowProSolid,
        faMagicProSolid,
        faMapMarkedAltProSolid,
        faMapPinProSolid,
        faMapProSolid,
        faMapSignsProSolid,
        faMicrophoneProSolid,
        faMinusCircleProSolid,
        faMinusProSolid,
        faMinusSquareProSolid,
        faMobileAltProSolid,
        faMoneyCheckAltProSolid,
        faMousePointerProSolid,
        faMusicProSolid,
        faNewspaperProSolid,
        faObjectUngroupProSolid,
        faPaintBrushProSolid,
        faPaperPlaneProSolid,
        faPasteProSolid,
        faPencilProSolid,
        faPepperHotProSolid,
        faPercentProSolid,
        faPhoneProSolid,
        faPlaneProSolid,
        faPlayProSolid,
        faPodcastProSolid,
        faPrintProSolid,
        faPumpkinProSolid,
        faPuzzlePieceProSolid,
        faQuestionCircleProSolid,
        faQuestionProSolid,
        faQuoteRightProSolid,
        faRamProSolid,
        faReceiptProSolid,
        faRecycleProSolid,
        faReplyProSolid,
        faRetweetProSolid,
        faRssProSolid,
        faSaveProSolid,
        faSearchProSolid,
        faShareAltProSolid,
        faSignInAltProSolid,
        faSignLanguageProSolid,
        faSignOutAltProSolid,
        faSlashProSolid,
        faSmileBeamProSolid,
        faSortAmountDownProSolid,
        faSortProSolid,
        faSparklesProSolid,
        faStarProSolid,
        faStarsProSolid,
        faStickyNoteProSolid,
        faStreetViewProSolid,
        faSuitcaseProSolid,
        faSyncAltProSolid,
        faTabletAltProSolid,
        faTachometerAltProSolid,
        faTasksAltProSolid,
        faTextProSolid,
        faThProSolid,
        faThumbsDownProSolid,
        faThumbsUpProSolid,
        faThumbtackProSolid,
        faTimesProSolid,
        faToggleOffProSolid,
        faToggleOnProSolid,
        faToolboxProSolid,
        faTrashAltProSolid,
        faTreeProSolid,
        faTrophyProSolid,
        faTvProSolid,
        faUndoProSolid,
        faUniversityProSolid,
        faUserCheckProSolid,
        faUserCircleProSolid,
        faUserPlusProSolid,
        faUserProSolid,
        faUsersProSolid,
        faUserTieProSolid,
        faUserTimesProSolid,
        faUtensilsProSolid,
        faVideoProSolid,
        faVolumeUpProSolid,
        faWifiProSolid,
        faWindowMaximizeProSolid,
        faWrenchProSolid,
        faPodiumProSolid,
        faShieldAltProSolid,
        faTasksProSolid,
        faCloneProSolid,

        faAddressCardProLight,
        faAddressBookProLight,
        faAngleDownProLight,
        faAngleUpProLight,
        faArrowAltCircleDownProLight,
        faArrowAltCircleRightProLight,
        faArrowAltCircleUpProLight,
        faArrowCircleDownProLight,
        faArrowCircleRightProLight,
        faArrowCircleUpProLight,
        faArrowDownProLight,
        faArrowLeftProLight,
        faArrowRightProLight,
        faArrowUpProLight,
        faAlignJustifyProLight,
        faBallotCheckProLight,
        faBookProLight,
        faBookProLight,
        faBookProLight,
        faBuildingProLight,
        faBullhornProLight,
        faBarsProLight,
        faCalendarAltProLight,
        faCalendarCheckProLight,
        faCheckProLight,
        faChildProLight,
        faCircleProLight,
        faPlusCircleProLight,
        faClockProLight,
        faCloudDownloadAltProLight,
        faCloudDownloadProLight,
        faCodeProLight,
        faCommentEditProLight,
        faColumnsProLight,
        faCommentsProLight,
        faCommentProLight,
        faCompassProLight,
        faCopyProLight,
        faCreditCardProLight,
        faCubesProLight,
        faCloneProLight,
        faDollarSignProLight,
        faDrawSquareProLight,
        faEditProLight,
        faEditProLight,
        faEmptySetProLight,
        faEnvelopeOpenTextProLight,
        faEnvelopeOpenProLight,
        faEnvelopeProLight,
        faExclamationCircleProLight,
        faEyeProLight,
        faExclamationTriangleProLight,
        faFileAltProLight,
        faFileArchiveProLight,
        faFileAudioProLight,
        faFileCsvProLight,
        faFileExcelProLight,
        faFileEditProLight,
        faFileImageProLight,
        faFileInvoiceDollarProLight,
        faFilePdfProLight,
        faFilePowerpointProLight,
        faFileProLight,
        faFileVideoProLight,
        faFileWordProLight,
        faFilterProLight,
        faFlagAltProLight,
        faFolderOpenProLight,
        faFolderProLight,
        faFoldersProLight,
        faGavelProLight,
        faGlobeProLight,
        faGlobeAmericasProLight,
        faGripLinesProLight,
        faHandshakeProLight,
        faHorizontalRuleProLight,
        faInfoCircleProLight,
        faLayerGroupProLight,
        faLevelUpProLight,
        faLightbulbProLight,
        faListUlProLight,
        faLinkProLight,
        faLocationProLight,
        faLockAltProLight,
        faLockOpenProLight,
        faLockProLight,
        faLongArrowDownProLight,
        faLongArrowLeftProLight,
        faLongArrowRightProLight,
        faLongArrowUpProLight,
        faMapProLight,
        faMapMarkerProLight,
        faMapMarkedAltProLight,
        faMapPinProLight,
        faMapSignsProLight,
        faMicrophoneProLight,
        faMinusProLight,
        faMinusCircleProLight,
        faMoneyBillAltProLight,
        faMoneyBillWaveProLight,
        faMoneyCheckAltProLight,
        faMoneyCheckEditAltProLight,
        faNewspaperProLight,
        faObjectUngroupProLight,
        faPaperclipProLight,
        faPencilAltProLight,
        faPencilProLight,
        faPhoneProLight,
        faPlusProLight,
        faRandomProLight,
        faReceiptProLight,
        faRectangleWideProLight,
        faRssProLight,
        faSaveProLight,
        faSearchProLight,
        faShareProLight,
        faSlashProLight,
        faSortAltProLight,
        faSortAmountDownProLight,
        faSortAmountDownProLight,
        faSortAmountUpProLight,
        faSparklesProLight,
        faSpinnerLight,
        faSquareProLight,
        faStarProLight,
        faStickyNoteProLight,
        faSuitcaseProLight,
        faTableProLight,
        faTachometerAltProLight,
        faTachometerAltProLight,
        faTasksAltProLight,
        faTextSizeProLight,
        faTextHeightProLight,
        faThumbsDownProLight,
        faThumbsUpProLight,
        faThumbtackProLight,
        faThumbtackProLight,
        faThumbtackProLight,
        faTimesCircleProLight,
        faTimesProLight,
        faUsdCircleProLight,
        faUserCircleProLight,
        faUserFriendsProLight,
        faUserLockProLight,
        faUserPlusProLight,
        faUserProLight,
        faUsersProLight,
        faUsersProLight,
        faUsersProLight,
        faVideoProLight,
        faPodiumProLight,
        faTasksProLight,
        faSmileBeamProLight,
        faIslandTropicalProLight,
        faUserTieProLight,

        faAddressCardProDuotone,
        faAddressBookProDuotone,
        faAlarmClockProDuotone,
        faAnalyticsProDuotone,
        faArchiveProDuotone,
        faArrowDownProDuotone,
        faArrowLeftProDuotone,
        faArrowRightProDuotone,
        faArrowToBottomProDuotone,
        faArrowUpProDuotone,
        faAtlasProDuotone,
        faBellExclamationProDuotone,
        faBookReaderProDuotone,
        faBrowserProDuotone,
        faBugProDuotone,
        faBuildingProDuotone,
        faBullhornProDuotone,
        faBullseyeArrowProDuotone,
        faCalendarCheckProDuotone,
        faChartBarProDuotone,
        faChartLineProDuotone,
        faChartNetworkProDuotone,
        faCheckCircleProDuotone,
        faCheckSquareProDuotone,
        faCheeseSwissProDuotone,
        faCloudDownloadAltProDuotone,
        faCogProDuotone,
        faCommentProDuotone,
        faCommentAltLinesProDuotone,
        faCommentDotsProDuotone,
        faCommentEditProDuotone,
        faCompassProDuotone,
        faCopyProDuotone,
        faDownloadProDuotone,
        faEditProDuotone,
        faEnvelopeOpenTextProDuotone,
        faEnvelopeOpenProDuotone,
        faEnvelopeProDuotone,
        faExclamationTriangleProDuotone,
        faEyeProDuotone,
        faFileAltProDuotone,
        faFileChartLineProDuotone,
        faFileChartPieProDuotone,
        faFileInvoiceDollarProDuotone,
        faFlagCheckeredProDuotone,
        faFlagProDuotone,
        faGlobeProDuotone,
        faGraduationCapProDuotone,
        faHandHoldingUsdProDuotone,
        faHandshakeProDuotone,
        faHourglassProDuotone,
        faKeySkeletonProDuotone,
        faLandmarkProDuotone,
        faListAltProDuotone,
        faListProDuotone,
        faListUlProDuotone,
        faLockAltProDuotone,
        faMapMarkedAltProDuotone,
        faMapProDuotone,
        faMicrophoneProDuotone,
        faMobileAltProDuotone,
        faMobileProDuotone,
        faMonumentProDuotone,
        faObjectUngroupProDuotone,
        faPaintBrushAltProDuotone,
        faPaintRollerProDuotone,
        faPaletteProDuotone,
        faPaperPlaneProDuotone,
        faPencilProDuotone,
        faPiggyBankProDuotone,
        faPodiumProDuotone,
        faPrintProDuotone,
        faRecycleProDuotone,
        faRssProDuotone,
        faSearchProDuotone,
        faShareAllProDuotone,
        faShieldProDuotone,
        faSlidersHProDuotone,
        faSlidersHSquareProDuotone,
        faSortAmountDownAltProDuotone,
        faSortAmountDownProDuotone,
        faStarProDuotone,
        faTableProDuotone,
        faTachometerAltFastProDuotone,
        faTachometerAltProDuotone,
        faTagsProDuotone,
        faTasksProDuotone,
        faThListProDuotone,
        faThumbsUpProDuotone,
        faThumbtackProDuotone,
        faTrophyAltProDuotone,
        faUploadProDuotone,
        faUserAltProDuotone,
        faUserCheckProDuotone,
        faUsersClassProDuotone,
        faUsersProDuotone,
        faUserSecretProDuotone,
        faPenSquareProDuotone,

        faAdnBrand,
        faAmazonBrand,
        faAndroidBrand,
        faAppleBrand,
        faBuyselladsBrand,
        faCcStripeBrand,
        faConnectdevelopBrand,
        faFacebookBrand,
        faFacebookFBrand,
        faFacebookSquareBrand,
        faGoogleBrand,
        faInstagramBrand,
        faInstagramSquareBrand,
        faLinkedInBrand,
        faLinkedinInBrand,
        faMediumBrand,
        faMediumMBrand,
        faMicrosoftBrand,
        faSlideshareBrand,
        faStripeBrand,
        faXTwitterBrand,
        faTwitterBrand,
        faTwitterSquareBrand,
        faYahooBrand,
        faYoutubeBrand,
        faYoutubeSquareBrand,

        faAddressCard,
        faAddressBook,
        faAngleUp,
        faArrowDown,
        faArrowLeft,
        faArrowRight,
        faArrowUp,
        faBan,
        faBolt,
        faBook,
        faBuilding,
        faBullhorn,
        faCalendarAlt,
        faCheckSquare,
        faChild,
        faCoffee,
        faCopy,
        faDownload,
        faEdit,
        faEnvelopeOpenText,
        faEnvelopeOpen,
        faExclamationCircle,
        faFileAlt,
        faFileWord,
        faGavel,
        faHamburgerProDuotone,
        faHandshake,
        faHistory,
        faInfo,
        faInfoCircle,
        faKey,
        faLightbulb,
        faLink,
        faMobileAlt,
        faMoneyBillAltSolid,
        faPaperclipSolid,
        faPaperPlane,
        faPencilAlt,
        faPlusCircle,
        faPhone,
        faPlus,
        faRss,
        faSaveProRegular,
        faSearch,
        faSearchLocation,
        faSearchPlus,
        faSpinner,
        faSquare,
        faSuitcase,
        faThumbtack,
        faTimesOctagonDuotone,
        faTrash,
        faUser,
        faUsers,
        faGlobe,

        faBoolean,
        faCards,
        faDashboard,
        faDashboardSmall,
        faDragHandle,
        faEUStars,
        faQuorumLogo,
        faAvatar,
        faBoltSlash,
        faSparkle,

        faUserCircleProRegular,
        faUserEditProRegular,
        faUserCog,
        faUserCogProDuotone,
        faUserCogProLight,
        faUserCogProRegular,
        faUserCogProSolid,
        faUsersCog,
        faUsersCogProDuotone,
        faUsersCogProLight,
        faUsersCogProRegular,
        faUsersCogProSolid,
        faTagProRegular,
        faFilterRegular,
        faFilterSlash,
        faNeutral,
        faBarsStaggered,
        faBasket,
        faQuorumLink,
        faQuorumCard,
        faQuorumList,
        faQuorumOneColumn,
        faQuorumTwoColumns,
        faQuorumThreeColumns,
    )
}

export const ICON_SIZES = ["lg","xs","sm","1x","2x","3x","4x","5x","6x","7x","8x","9x","10x"]
